import _ from 'lodash';
import REST from 'go/requests/rest';
import React from 'react';
import JSONPath from 'jsonpath';
import momentBusinessDays from 'moment-business-days';
import moment from 'moment-timezone';
import uuidv4 from 'uuid/v4';
import {
  withGuidance,
  withValidation,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls/HOCs';
import ReactHtmlParser from 'react-html-parser';
import {multiply, bignumber, number, divide, add} from 'mathjs';
import {
  ROLE_MAP,
  ENTITY_MAP,
  MOMENT_EST,
  REQUEST_DETAILS_CHANGES_TYPES,
  REQUEST_DETAILS_VALUE_CHANGE_DISPLAY,
  BANKING_PERMISSION_ROLES,
  HOLIDAYS,
  PREAWARD_STATUSES,
  STATUS_SUBMITTED_TO_FEMA,
  STATUS_NOT_SUBMITTED,
  STATUS_AWARD_ACCEPTED,
  ASSOCIATED_ENTITY_STATUSES,
  STATUS_PENDING_SUBMISSION,
  BEFORE_FINAL_SUBMISSION_STATUSES,
  profilePhoneNumberOptions,
  phoneNumberOptions,
  STATUS_SUBMITTED_TO_RECIPIENT,
  STATUS_RETURNED_TO_SUBRECIPIENT,
  STATUS_PENDING_SAR_SIGNATURE,
  STATUS_APPROVED_BY_RECIPIENT,
  STATUS_DISAPPROVED_BY_RECIPIENT,
  STATUS_RETURNED_TO_RECIPIENT,
  STATUS_STOCKPILE,
  ENTITY_PAGE_TYPE_SUBGRANT,
  STATUS_INELIGIBLE,
  STATUS_NOT_SELECTED,
  CAN_SUBMIT,
  CAN_SUBMIT_POSITIVE,
  PANEL_STATUS_CHANGE_DISPLAY,
  GRANT_ACTIONS_REQUIRED_TOGGLES,
  ACTIVITY_RESPONSES,
  RECRUITMENT_AND_RETENTION,
  HIRING_OF_FIREFIGHTERS,
  SUB_AWARD_REC_INDX_ERROR,
  STATUS_SUBAWARD_OFFERED,
  STATUS_SUBAWARD_DECLINED,
  STATUS_SUBAWARD_ACCEPTED,
  STATUS_SAVED_FOR_LATER,
  STATUS_PENDING_AOR_SUBMISSION,
  AUTHORIZED_VIEW_SUB_APP_ROLES,
  STATUS_APPROVED,
  STATUS_DENIED,
  STATUS_CLOSEOUT_INITIATED,
  COOKIES,
  STATUS_CLOSED,
  STATUS_SUBAWARD_RESCINDED,
} from 'app-ui-componentlibrary/dist/common/constants';
import PermissionChecks, {
  canViewPostAwardEntities,
  canViewAndContinueApplication,
  canContinueApplications,
  canReopenApplications,
  canCancelCloseoutReport,
  canContinueSubapplicationSubmitted,
  canViewSubapplication,
  canViewAndContinueSubapplication,
  canViewSubGrantAmendmentsAndPayments,
  canInitiateOrContinueSubCloseoutReport,
  canCancelSubCloseoutReport,
  isSM,
  rfiSectionCheck,
  canCreateSubgrantPaymentRequest,
  hasScopedRoles,
  canSubmitSubapplicationsToFEMA,
  isSAR,
  isAOR,
  canViewAdminConsoleTab2,
} from 'go/security/permissions';
import {SARROLES, AOR_SAR_ROLES} from 'go/components/organization/team/constants';
import {countQuantityOfItem} from 'common/requestDetails/utils';
import {
  calculateChildrenTotalByMode,
  calculateItemCostTotal,
  calculateAllItemsCategorizedCostTotal,
} from 'common/requestDetails/utils';
import {
  FUNDING_STREAM_NAME,
  PAYMENT,
  ENTITY_TYPE_SUBGRANT,
} from 'common/requestDetails/constants.js';
import jsonPath from 'jsonpath';
import {
  PROPERTY_TYPES_CODES,
  PROPERTY_TYPES_LABELS,
} from 'go/components/dynamic/modules/projectSiteInventory/constants';

import {
  SUBAPPLICATION_PATHS,
  SUBAPPLICATION_RANK_ERROR_MSGS,
} from 'go/components/application/constants';

import {email_regex} from 'go/components/organization/team/constants';
import {setTimeout} from 'core-js';
import goStore from 'go/store';
import {unpartitionedToggleIsOn} from 'common/storeUtils';
import permissions from 'go/security/permissions';
import Cookies from 'universal-cookie';
import {retry} from '@lifeomic/attempt';
import jwt_decode from 'jwt-decode';

export const phoneTypeProfileToContacts = (type) => {
  return _.toLower(
    _.get(
      _.find(profilePhoneNumberOptions, (option) => option.value == type),
      'text',
      _.get(
        _.find(phoneNumberOptions, (option) => option.value == type),
        'text',
        ''
      )
    )
  );
};

export const filterEntities = (entities, excludedIds, includedStatuses) => {
  return _.filter(entities, (entity) => {
    return (
      !_.includes(excludedIds, entity.entityId) &&
      _.includes(includedStatuses, entity.status)
    );
  });
};

const getItemsOfCostTypeHelper = (item, refs, costType, path) => {
  let items = [];
  const itemCostType = _.get(
    _.find(refs, (ref) => ref.itemCode === item.itemCode),
    'costType'
  );
  if (costType === itemCostType) {
    const itemToPush = _.cloneDeep(item);
    itemToPush.awardedId = _.join(path, '.');
    items.push(itemToPush);
  }
  _.forEach(item.children, (child, pathKey) => {
    items = _.concat(
      items,
      getItemsOfCostTypeHelper(child, refs, costType, [...path, 'children', pathKey])
    );
  });
  return items;
};

export const getItemsOfCostType = (fundingStreams, refs, costType) => {
  let items = [];
  _.forEach(fundingStreams, (stream, streamInd) => {
    _.forEach(stream.children, (child, childKey) => {
      items = _.concat(
        items,
        getItemsOfCostTypeHelper(child, refs, costType, [streamInd, 'children', childKey])
      );
    });
  });
  return items;
};

export const hasItemOfCostType = (fundingStreams, refs, costType) => {
  return _.size(getItemsOfCostType(fundingStreams, refs, costType)) > 0;
};

export const sortAndPartitionEmployeesByStartDate = (position) => {
  const sortedPosition = _.reverse(
    _.sortBy(position, (pos) => moment(pos.startDate).valueOf())
  );

  return _.partition(sortedPosition, (pos) => !pos.endDate);
};

export const checkForValidationErrors = (errs, componentsToCheck) => {
  let errorComponents = [];
  if (errs && componentsToCheck) {
    _.forEach(componentsToCheck, (comp) => {
      const err = errs[comp];
      if (err) {
        _.forEach(err, (error) => {
          if (!error.isValid) {
            errorComponents.push(comp);
            return false;
          }
        });
      }
    });
  }
  return errorComponents;
};

export const getPropValues = (o, prop) =>
  ((validationIdList) => (
    JSON.stringify(
      o,
      (key, value) => (key === prop && validationIdList.push(value), value)
    ),
    validationIdList
  ))([]);

export const shouldDisplaySection = (section, props, shouldDisplay) => {
  if (section.type === 'ShowHide') {
    let isHidden = !shouldDisplay(undefined, undefined, section.shouldDisplayRules, {
      ...props,
      shouldDisplayIfAnyRules: section.shouldDisplayIfAnyRules,
    });
    if (isHidden) {
      return false;
    }
  }
  return true;
};

const buildActionLink = async (
  permissions,
  token,
  entityId,
  entitytype,
  grantId,
  status
) => {
  return new Promise(async (resolve) => {
    const taskTypes = {
      financialReport: 'submitFinancialReport',
      rfi: 'completeRfiUserTask',
      bsirReport: 'submitBSIRReport',
      subApplication: 'subAppSubmissionToFEMA',
      performanceProgressReport: 'submitPPRReport',
    };
    const fetchBody = {
      candidateGroups: permissions,
      includeAssignedTasks: true,
      processVariables: [
        {
          name: 'grantId',
          value: `%${grantId}%`,
          operator: 'like',
        },
      ],
      taskDefinitionKey: taskTypes[entitytype],
    };
    let retrieveTaskLink = false;
    if (_.includes(_.keys(taskTypes), entitytype)) retrieveTaskLink = true;
    if (entitytype === 'subApplication' && status !== 'pendingAorSubmission')
      retrieveTaskLink = false;
    if (retrieveTaskLink) {
      const url = await REST.workflow
        .getAllExternalEligibleTasks(token, ['grantId'], fetchBody)
        .then(REST.handler.handleResponse);
      return resolve(_.size(url) > 0 ? `/tasks/${url[0].id}` : '#');
    }
    if (entitytype === 'grant') {
      return resolve(`/${entitytype}/${entityId}`);
    }
    return resolve(`/${entitytype}/${entityId}/edit`);
  });
};

export const getActionVal = async (perms, token, thingsToDo) => {
  const results = await Promise.all(
    _.map(thingsToDo, async (thing) => ({
      ...thing,
      actionVal: await buildActionLink(
        perms,
        token,
        thing.entityId,
        thing.entityType,
        thing.grantId,
        thing.status
      ),
    }))
  );
  return results;
};

export const evalSectionStatus = (section, allValidationErrors) => {
  let validationIdList = getPropValues(section, 'validationId');
  let errorInSection = false;

  _.forEach(validationIdList, (validationId) => {
    if (!_.isEmpty(validationId)) {
      let errorList = _.get(allValidationErrors.errors, validationId);
      if (!_.isEmpty(errorList)) {
        const errorFound = _.find(errorList, (err) => err.isValid === false);
        if (errorFound !== undefined) {
          errorInSection = true;
        }
      }
    }
  });

  return errorInSection ? 'needsAttention' : 'complete';
};

/** UTILITY FUNCTIONS SITE-WIDE **/

export const generateOptionsFromRefData = (ids, list, compareItem) => {
  let formattedList = [];
  _.forEach(ids, (id) => {
    _.forEach(list, (item) => {
      if (compareItem !== undefined) {
        if (id[compareItem] === item.id) {
          formattedList.push(item);
        }
      } else if (id === item.id) {
        formattedList.push(item);
      }
    });
  });
  return mapRefData(formattedList);
};

export const mapRefData = (obj) =>
  _.map(obj, (x) => {
    return mapToTextAndValue(x.displayText, x.id);
  });

export const mapRefDataCode = (obj) =>
  _.map(obj, (x) => {
    return mapToTextAndValue(x.displayText, x.code);
  });

export const mapLocationRefDataByIdOrCode = (obj, type) => {
  return _.map(obj, (item) => {
    const {displayText = '', code = '', id = '', displayOrder = ''} = item;
    return {
      text: displayText,
      value: type === 'code' ? code : displayText,
      key: type === 'code' ? code : id,
      displayOrder: displayOrder,
    };
  });
};

export const mapLocationRefDataByIdAndCode = (obj, type) => {
  return _.map(obj, (item) => {
    const {displayText = '', code = '', id = '', displayOrder = ''} = item;
    return {
      text: displayText,
      value: type === 'code' ? code : displayText,
      key: type === 'code' ? code : id,
      displayOrder: displayOrder,
      id,
    };
  });
};

export const mapLocationRefDataByCode = (obj, type) => {
  return _.map(obj, (item) => {
    let refObj = {};
    refObj.text = type === 'code' ? item.code : '';
    return refObj;
  });
};

export const mapToTextAndValue = (text, value) => {
  return {
    key: value,
    value: value,
    text: text,
  };
};

export const isValidDuns = (dunsNum, isDunsPlus4) => {
  if (dunsNum) {
    dunsNum = dunsNum.toString().replace(/\D/g, 'X');
    let isValidLength = dunsNum.length === 9 || dunsNum.length === 13;
    if (isDunsPlus4) {
      isValidLength = dunsNum.length === 4;
    }
    return dunsNum && isValidLength && !isNaN(dunsNum);
  }
  return false;
};

export const isValidUei = (uei, isEft) => {
  if (uei) {
    let isValidLength = uei.length === 12 || (uei.length === 17 && uei.includes('-'));

    if (isEft) {
      isValidLength = uei.length === 4;
    }
    return uei && isValidLength;
  }
  return false;
};

export const checkIsNum = (o) => {
  return typeof o === 'number' && !isNaN(o);
};

export const cutDateTimeOff = (date) => {
  if (date === null || date === undefined || typeof date !== 'string') {
    return '';
  }
  return date.substr(0, 10);
};

export const formatDateMMDDYYYY = (value) => {
  let date = cutDateTimeOff(value);
  if (date === '') {
    return '';
  }
  const year = getYear(date);
  const month = getMonth(date);
  const day = getDay(date);
  return month + '/' + day + '/' + year;
};

const getYear = (date) => {
  return date.substring(0, 4);
};

const getMonth = (date) => {
  var newDate = date.slice(5);
  return newDate.substr(0, 2);
};

const getDay = (date) => {
  return date.substr(8, 10);
};

// takes a string describing a number and makes sure it has 2 decimals at the end
// e.g 10 -> 10.00 or 23.3 -> 23.30 or 23.4044 -> 23.40
export const formatDollarDecimals = (valueString) => {
  let indexPeriod = valueString.indexOf('.');
  let indexAfterPeriod = indexPeriod + 1;
  // value is a float, format according to dollar syntax
  if (indexPeriod !== -1) {
    var valTruncated = valueString.substring(0, indexAfterPeriod);
    var decimals = valueString.substring(indexAfterPeriod);
    switch (decimals.length) {
      case 0: {
        decimals += '00';
        break;
      }
      case 1: {
        decimals += '0';
        break;
      }
      default: {
        decimals = decimals.substring(0, 2);
        break;
      }
    }
    return valTruncated + decimals;
    // value is an integer, just add decimals to string
  } else {
    return valueString + '.00';
  }
};

export const formatDollarHyphen = (valueString) => {
  let hasHyphen = valueString.indexOf('-') !== -1;
  if (hasHyphen) {
    return '-' + valueString.replaceAll('-', '');
  } else {
    return valueString;
  }
};

// takes a string describing a number and makes sure it has commas at
// appropriate places 10.00 -> 10.00, 1000 -> 1,000, 100000.0 -> 100,000.0
export const formatDollarCommas = (valueString) => {
  var hasDecimal = valueString.indexOf('.') !== -1;
  let parts = valueString.split('.');
  if (parts[0].length === 0) {
    parts[0] = '0';
  } else {
    // TODO merge the first 2 regex
    // 1. Remove all leading 0's except last
    // 2. Remove leading zero if it is not alone (0.00 should be valid)
    // 3. add in commas
    parts[0] = parts[0]
      .replace(/^0+(?=0)/, '')
      .replace(/^0(?!0)(?=\w)/, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  if (hasDecimal) {
    return parts.join('.');
  } else {
    return parts[0];
  }
};

// take a string and remove all but 2 characters after the string's first '.'
export const onlyTwoDecimals = (value) => {
  let splitAtDecimal = value.split('.');
  if (splitAtDecimal.length < 2) {
    return splitAtDecimal[0];
  } else if (splitAtDecimal[1].length < 2) {
    return value;
  } else {
    splitAtDecimal[1] = splitAtDecimal[1].substring(0, 2);
    return splitAtDecimal.join('.');
  }
};

export const getCostsTotalForAttribute = (costs, attribute) => {
  let total = 0;
  _.map(costs, (costArray, ind) => {
    const value = parseFloat(_.get(costArray[0], attribute));
    if (!isNaN(value)) total = safeAdd(total, value);
  });
  if (total === 0) return '';
  return total;
};

export const convertValueToDollar = (value) => {
  if (value !== null && value !== undefined) {
    const num = onlyAllowNumbers(value.toString());
    return showDollarAmountWithDollar(num);
  } else {
    return showDollarAmountWithDollar(value);
  }
};

// do not use directly if also displaying a dollar sign
// use showDollarAmountwithDollar for consistent formatting
export const showDollarAmount = (value) => {
  let num = value;
  if (num != '0' && (!num || isNaN(num))) {
    return 0;
  } else {
    return formatDollarDecimals(formatDollarCommas(num.toString()));
  }
};

export const formatDollarDecimalsNullSafe = (value) => {
  let num = value;
  if (!num || isNaN(num)) {
    return 0;
  } else {
    return formatDollarDecimals(num.toString());
  }
};

export const showDollarAmountWithDollar = (value) => {
  let num = value;
  if (isNaN(num) || value === '' || value === null || typeof value === 'undefined') {
    return '$';
    // negative numbers should be in '-$xx.xx' format:: 2299
  } else if (num < 0) {
    return '-$' + showDollarAmount(0 - num);
  } else {
    return '$' + showDollarAmount(num);
  }
};

export const showPercentageAmountWithPercentage = (value) => {
  if (isNaN(value) || checkIfValuesAre([null, undefined, '', ' '], value)) {
    return ' %';
  }

  return formatNumber(value) + ' %';
};

export const formatNumber = (value) => {
  if (value !== null && !isNaN(value)) {
    let num = value.toString();
    if (num === '0') {
      return '0';
    }
    let parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  } else {
    return null;
  }
};

export const formatLineNumber = (lineNumber) => {
  if (lineNumber === undefined) return lineNumber;
  while (`${lineNumber}`.length < 3) lineNumber = '0' + `${lineNumber}`;
  return lineNumber;
};

export const stringToNum = (value) => {
  let str = value.toString();
  return parseFloat(str.replace(/\$|,/g, ''));
};

export const onlyAllowNumbers = (value, positiveOnly) => {
  if (typeof value !== 'undefined' && value !== null) {
    if (positiveOnly) {
      value = value.toString().replace(/[^0-9\.]/g, '');
    } else {
      value = value.toString().replace(/[^0-9\.\-]/g, '');
    }
    const indOfPeriod = value.indexOf('.');
    if (indOfPeriod !== -1) {
      let noPeriodValue = value.replace(/\./g, '');
      value =
        noPeriodValue.substring(0, indOfPeriod) +
        '.' +
        noPeriodValue.substring(indOfPeriod, noPeriodValue.length);
    }
    return value.replace(/\.+(?=\.)/g, '');
  } else {
    return value;
  }
};
export const allowNumbersAndPeriods = (value) => {
  if (value !== null && value !== undefined && value.match(/^(\d*\.?\d{0,2})$/)) {
    return value.match(/^(\d*\.?\d{0,2})$/)[0];
  } else {
    return false;
  }
};

// converts to an integer
export const convertToNum = (value, config) => {
  if (value !== null && value !== undefined) {
    let str = value.toString();
    str = str.replace('$', '');
    str = str.replace('%', '');
    str = str.replace(' ', '');
    str = str.replace(/,/g, '');

    if (isNaN(parseInt(str, 10))) {
      value = null;
    } else {
      value = _.get(config, 'convertToInt') === false ? str : parseInt(str, 10);
    }
  }

  return value;
};

export const sanitizeNum = (value) => {
  if (value !== null && value !== undefined) {
    let str = value.toString();
    str = str.replace(/,/g, '');
    return str;
  }
  return value;
};

export const endsWith = (str, suffix) => {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
};

export const sanitizeDate = (field) => {
  if (field) {
    let dateToSanitize = cutDateTimeOff(field);
    dateToSanitize = new Date(dateToSanitize);
    dateToSanitize.setUTCHours(12, 0, 0, 0);
    dateToSanitize = dateToSanitize.toISOString();
    return dateToSanitize;
  } else {
    return null;
  }
};

export const formatLatitude = (input) => {
  const value = +input;
  if (isNaN(value)) {
    return;
  }
  const isNegative = value < 0 ? '-' : '';
  const parts = Math.abs(value).toString().split('.');
  if (parts.length === 1) {
    const nums = parts[0];
    parts[0] = nums.substr(0, 2);
    parts[1] = nums.substr(2, 6);
  }
  return (
    isNegative + parts[0].padStart(2, '0') + '.' + parts[1].padEnd(6, '0').substr(0, 6)
  );
};

export const formatLongitude = (input) => {
  const value = +input;
  if (isNaN(value)) {
    return;
  }
  const isNegative = value < 0 ? '-' : '';
  const parts = Math.abs(value).toString().split('.');
  if (parts.length === 1) {
    const nums = parts[0];
    parts[0] = nums.substr(0, 3);
    parts[1] = nums.substr(3, 6);
  }
  return (
    isNegative + parts[0].padStart(3, '0') + '.' + parts[1].padEnd(6, '0').substr(0, 6)
  );
};

export const FORMATTERS = {
  formatLatitude,
  formatLongitude,
};

export const commonJwtHeader = () => {
  const state = goStore.store.getState();
  const token = _.get(state, 'auth.token');
  var headers = {
    'Content-Type': 'application/json',
    accept: 'application/json',
    pragma: 'no-cache',
    'cache-control': 'no-cache',
  };
  // if (!token) {
  //   return headers;
  // }
  headers._csrftoken = _.get(token, '_csrftoken');
  return _.merge(headers, getSRFTokens());
};
const getSRFTokens = () => {
  var cookies = document.cookie.split(';');
  const cookieName = 'XSRF-TOKEN-';
  let _csrftokens = {};
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(cookieName) && cookie.indexOf('=') > -1) {
      const csrf = cookie.split('=');
      _.set(
        _csrftokens,
        'X-' + _.get(csrf, 0, cookieName),
        decodeURIComponent(_.get(csrf, 1))
      );
    }
  }
  return _csrftokens;
};

export const commonJwtHeaderNoCT = () => {
  let headers = commonJwtHeader();
  delete headers['Content-Type'];
  return headers;
};

export const getUpdatedReduxStatePayload = (data, dataPath, updatedData) => {
  let path = `payload.${dataPath}`;
  let dataCloned = Object.assign({}, data);
  if (dataPath === '') {
    path = 'payload';
  }
  _.set(dataCloned, path, updatedData);
  return dataCloned;
};

export const getUpdatedReduxState = (data, dataPath, updatedData) => {
  let path = dataPath || '';
  _.set(data, path, updatedData);
  return data;
};
export const removeDataFromReduxState = (data, dataPath) => {
  _.unset(data, dataPath);
  return data;
};

/** This is used to generate the unique ID needed for react rows. When in prod.. we will probably already have a unique key that we could use, but for now I'm generating a random one.
 * @return {text}
 */
export const createUUID = () => {
  return uuidv4();
};

/**
 * Generate time like UUID.
 * @returns {string}
 */
export const generateTimeId = () => {
  const timestamp = Date.now();
  const randomBytes = new Uint8Array(8);
  crypto.getRandomValues(randomBytes);
  const randomHex = Array.from(randomBytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return `g${timestamp}-${randomHex}`;
};
/**
 * Checks if value is in array
 * @param {[]} array
 * @param {string} value
 */
export const checkIfIncludedsIn = (array, value) => {
  return _.some(array, (arrayValue) => {
    return arrayValue === value;
  });
};

const invalidNumber = (number, length) =>
  !number || number.length != length || isNaN(number);

export const validatePhoneNumber = (number) => {
  const {areaCode, phoneNumber, phoneType, phoneExtension} = number;
  number.phoneError = invalidNumber(areaCode, 3) || invalidNumber(phoneNumber, 7);
  number.phoneTypeError = !phoneType;
  number.phoneExtensionError = phoneExtension && isNaN(phoneExtension);
  return number.phoneError || number.phoneTypeError || number.phoneExtensionError;
};

const getOutOfSequenceNumbers = (numbers, total) => {
  let result = [];
  // Only if all entered
  if (_.size(numbers) === total) {
    for (let i = 1; i < total + 1; i++) {
      if (!_.includes(numbers, i)) {
        result.push(i);
      }
    }
  }
  return result;
};

const getAllSubapplicationRanks = (linksData) => {
  const allRanks = _.map(linksData, (link) => {
    return {
      entityId: link.entityId,
      payload: {
        rank: _.get(link, SUBAPPLICATION_PATHS.rank),
      },
    };
  });
  return allRanks;
};

export const validateSubapplication = (entityId, props) => {
  let {errors = {}} = props;
  const {applicationLinksData, categoryLabel} = props;
  const allRanks = getAllSubapplicationRanks(applicationLinksData);

  // Only ranks for the entities in the same category
  const subApplicationCategory = _.chain(applicationLinksData)
    .find({entityId: entityId})
    .get(SUBAPPLICATION_PATHS.subAppCategory)
    .value();

  const excludedRankCategories = ['Management costs', 'Technical assistance'];

  // Getting result rows with the same category
  const newResultsForRanks = _.chain(applicationLinksData)
    .filter((result) => {
      return (
        _.get(result, SUBAPPLICATION_PATHS.subAppCategory) === subApplicationCategory
      );
    })
    .reduce((accum, res) => {
      accum.push(res.entityId);
      return accum;
    }, [])
    .value();

  if (allRanks && !_.includes(excludedRankCategories, subApplicationCategory)) {
    // Getting ranks for results with the category from above
    const newRanks = _.filter(allRanks, (rank) => {
      return _.includes(newResultsForRanks, rank.entityId);
    });
    let ranks = [];
    let ranksToo = [];
    _.forEach(newRanks, (item) => {
      const rank = _.get(item, SUBAPPLICATION_PATHS.rank, undefined);
      if (rank !== undefined && item.entityId !== entityId) {
        ranks.push(parseInt(rank, 10));
        ranksToo.push({entityId: item.entityId, rank: parseInt(rank, 10)});
      }
    });
    const rankInput = _.chain(applicationLinksData)
      .find((res) => res.entityId === entityId)
      .get(SUBAPPLICATION_PATHS.rank, '')
      .value();

    const rank = parseFloat(rankInput, 10);

    let outOfSequenceNums = [];
    if (!isNaN(rank)) {
      outOfSequenceNums = getOutOfSequenceNumbers(
        _.concat(_.map(ranksToo, 'rank'), rank),
        _.size(newResultsForRanks)
      );
    }

    // Field level validations
    if (isNaN(rank) || typeof rank === 'undefined') {
      _.set(
        errors,
        [entityId, 'rank', 'errorMessage'],
        SUBAPPLICATION_RANK_ERROR_MSGS.default
      );
    } else if (rank % 1 !== 0 || toString(rankInput).indexOf('.') > -1) {
      _.set(
        errors,
        [entityId, 'rank', 'errorMessage'],
        SUBAPPLICATION_RANK_ERROR_MSGS.wholeNumber
      );
    } else if (rank === 0 || rank < 0) {
      _.set(
        errors,
        [entityId, 'rank', 'errorMessage'],
        SUBAPPLICATION_RANK_ERROR_MSGS.positiveNumber
      );
    } else if (isStringOfNumbers(rankInput)) {
      _.set(
        errors,
        [entityId, 'rank', 'errorMessage'],
        SUBAPPLICATION_RANK_ERROR_MSGS.default
      );
    } else if (_.includes(_.map(ranksToo, 'rank'), rank)) {
      _.set(
        errors,
        [entityId, 'rank', 'errorMessage'],
        SUBAPPLICATION_RANK_ERROR_MSGS.duplicates
      );
    } else {
      _.unset(errors, [entityId, 'rank', 'errorMessage']);
      // Re-check and unset other duplicates errors if needed
      let counts = {};
      _.forEach(ranksToo, (row) => {
        counts[row.rank] = (counts[row.rank] || 0) + 1;
      });
      _.forEach(ranksToo, (row) => {
        if (counts[row.rank] > 1) {
          _.set(
            errors,
            [row.entityId, 'rank', 'errorMessage'],
            SUBAPPLICATION_RANK_ERROR_MSGS.duplicates
          );
        } else {
          _.unset(errors, [row.entityId, 'rank', 'errorMessage']);
        }
      });
    }

    const actualRanks = _.map(newRanks, (entity) => _.get(entity, 'payload.rank'));
    const filledRanks = _.filter(actualRanks, (r) => r != undefined && r != '');
    const allFilled = filledRanks.length === actualRanks.length;
    const atLeastOneFilled = filledRanks.length >= 1;

    // Category level validations
    if (atLeastOneFilled && !_.includes(actualRanks, '1')) {
      _.set(errors, [subApplicationCategory, 'errorTitle'], 'Rankings must start with 1');
      _.set(
        errors,
        [subApplicationCategory, 'errorMessage'],
        'You must have a subapplication with ranking value of 1.'
      );
      _.set(errors, [subApplicationCategory, 'errorExtras'], '');
    } else if (_.size(outOfSequenceNums) > 0 && allFilled) {
      _.set(
        errors,
        [subApplicationCategory, 'errorTitle'],
        'Rankings must be sequential'
      );
      _.set(
        errors,
        [subApplicationCategory, 'errorMessage'],
        categoryLabel +
          ' rankings must be sequential (1, 2, 3, ...). This ' +
          _.toLower(categoryLabel) +
          ' has ' +
          _.size(_.concat(ranks, rank)) +
          ' subapplications and is missing ranking value(s) '
      );
      _.set(
        errors,
        [subApplicationCategory, 'errorExtras'],
        _.join(outOfSequenceNums, ', ') + '.'
      );
    } else {
      _.unset(errors, [subApplicationCategory, 'errorMessage']);
    }
  } else {
    _.unset(errors, [subApplicationCategory, 'errorMessage']);
  }

  // Category level validations for Technical Assistance and Management Costs
  if (
    _.size(newResultsForRanks) > 1 &&
    _.includes(excludedRankCategories, subApplicationCategory)
  ) {
    _.set(
      errors,
      [subApplicationCategory, 'errorTitle'],
      'Only one subapplication allowed'
    );
    _.set(
      errors,
      [subApplicationCategory, 'errorMessage'],
      'This funding category can only have one subapplication. Please remove any additional subapplication(s).'
    );
  } else {
    const technicalAssistance = 'technical assistance';
    const managementCosts = 'management costs';
    _.forEach(applicationLinksData, (item) => {
      const subAppCategory = _.get(item, SUBAPPLICATION_PATHS.subAppCategory, '');
      const lowersubApplicationType = _.chain(item)
        .get('subApplicationType', '')
        .toLower()
        .value();
      if (_.toLower(subAppCategory) === technicalAssistance) {
        if (lowersubApplicationType.indexOf(technicalAssistance) === -1) {
          _.set(
            errors,
            [subAppCategory, 'errorTitle'],
            'Only technical assistance subapplications allowed'
          );
          _.set(
            errors,
            [subAppCategory, 'errorMessage'],
            `This ${_.toLower(
              categoryLabel
            )} can only have a subapplication with the technical assistance type. Please remove any subapplication(s) that are not this type.`
          );
        }
      } else if (_.toLower(subAppCategory) === managementCosts) {
        if (managementCosts.indexOf(lowersubApplicationType) === -1) {
          _.set(
            errors,
            [subAppCategory, 'errorTitle'],
            'Only management costs subapplications allowed'
          );
          _.set(
            errors,
            [subAppCategory, 'errorMessage'],
            `This ${_.toLower(
              categoryLabel
            )} can only have a subapplication with the management costs type. Please remove any subapplication(s) that are not this type.`
          );
        }
      }
    });
  }

  return errors;
};

export const validateAllSubapplications = (props) => {
  let errors = {};
  const {applicationLinksData, categoryLabel} = props;

  _.forEach(applicationLinksData, (row) => {
    const validationProps = {
      applicationLinksData: applicationLinksData,
      categoryLabel: categoryLabel,
    };
    _.merge(errors, validateSubapplication(row.entityId, validationProps));
  });

  return errors;
};

export const displayPhoneNumber = (areaCode, phoneNumber) => {
  let value = '';
  if (areaCode) {
    value += '(' + areaCode;
  }
  if (phoneNumber) {
    value += ') ' + phoneNumber.substr(0, 3);
    if (phoneNumber.length > 3) {
      value += '-' + phoneNumber.substr(3, 7);
    }
  }

  return value;
};

export const getLastFieldInPath = (path) => {
  return path.substr(path.lastIndexOf('.') + 1, path.length);
};
/**
 * retrieveEntityIdFromPermissions takes array of state.auth.permissions and reeturns the entityId
 * @param {[]} array
 * @return {string}
 */
export const retrieveEntityIdFromPermissions = (permissions) => {
  if (_.isEmpty(permissions)) {
    return '';
  } else {
    return permissions[0].charAt(0);
  }
};

export const retrieveAllEntityIdsFromPermissions = (permissions) => {
  if (_.isEmpty(permissions)) {
    return '';
  } else {
    return _.uniq(_.map(permissions, (permission) => permission.split(':')[0]));
  }
};
export const getUserEntitiesForEntityType = (permissions, entityType) => {
  return _.chain(permissions)
    .map((permission) => {
      let [entityTypeId, entityId, roleId] = permission.split(':');
      if (entityTypeId === entityType && entityId) {
        return entityId;
      }
    })
    .filter((sessionId) => sessionId !== undefined)
    .uniq()
    .value();
};

/**
 * retrieveRolesFromPermissions takes array of state.auth.permissions and returns an array of roleIds
 * @param {[]} array
 * @return {string}
 */
export const retrieveRolesFromPermissions = (permissions) => {
  const re = /[^:]*$/;
  if (_.isEmpty(permissions)) {
    return [];
  } else {
    return _.uniq(
      _.map(permissions, (permission) => {
        return permission.match(re)[0];
      })
    );
  }
};

export const retrieveEntityTypeIdsFromPermissions = (permissions) => {
  if (_.isEmpty(permissions)) {
    return [];
  } else {
    return _.uniq(
      _.map(permissions, (permission) => {
        return permission.split(':')[0];
      })
    );
  }
};

export const retrievePanelSessionsFromPermissions = (permissions) => {
  if (_.isEmpty(permissions)) {
    return [];
  } else {
    return _.chain(permissions)
      .map((permission) => {
        let [entityTypeId, panelSessionId, role] = permission.split(':');
        if (
          entityTypeId == ENTITY_MAP.PANEL_REVIEW.code &&
          (role == ROLE_MAP.PC.code ||
            role == ROLE_MAP.PR.code ||
            role == ROLE_MAP.PRC.code ||
            role == ROLE_MAP.PANELADMIN.code)
        ) {
          return panelSessionId;
        }
      })
      .filter((sessionId) => sessionId !== undefined)
      .uniq()
      .value();
  }
};

export const retrieveEntityIdFromPermissionsWithRoleAndType = (
  permissions,
  roleToCheck,
  entityType
) => {
  if (_.isEmpty(permissions)) {
    return [];
  } else {
    return _.chain(permissions)
      .map((permission) => {
        let [entityTypeId, entityId, role] = permission.split(':');
        if (role == roleToCheck && entityTypeId == entityType) {
          return entityId;
        }
      })
      .filter((entityId) => entityId !== undefined)
      .uniq()
      .value();
  }
};

export const isUserRoleAllowed = (permissions, orgId, roleId) => {
  if (_.isEmpty(permissions)) {
    return false;
  } else {
    return _.chain(permissions)
      .map((permission) => {
        let [entityTypeId, entityId, role] = permission.split(':');
        if (
          entityId == orgId &&
          entityTypeId == ENTITY_MAP.ORGANIZATION.code &&
          role == roleId
        ) {
          return true;
        }
      })
      .filter((value) => value !== undefined)
      .uniq()
      .value()[0];
  }
};

export const isUserOrgProgramAllowed = (permissions, orgId, roleId) => {
  if (_.isEmpty(permissions)) {
    return false;
  } else {
    return _.chain(permissions)
      .map((permission) => {
        let [entityTypeId, entityId, role] = permission.split(':');
        entityId = entityId.split('_')[0];
        if (
          entityId == orgId &&
          entityTypeId == ENTITY_MAP.PROGRAM_ORGANIZATION.code &&
          role == roleId
        ) {
          return true;
        }
      })
      .filter((value) => value !== undefined)
      .uniq()
      .value()[0];
  }
};

export const isUserAllowedBulk = (fns, permissions, orgId, roleIds) => {
  const fnMap = {
    isUserRoleAllowed,
    isUserOrgProgramAllowed,
  };
  return !!_.chain(roleIds)
    .flatMap((roleId) => _.flatMap(fns, (fn) => fnMap[fn](permissions, orgId, roleId)))
    .filter((allowed) => allowed)
    .value()[0];
};

export const isUserOrgPrgSuborgSelfSarSm = (permissions, suborgId, roleId) => {
  if (_.isEmpty(permissions)) {
    return false;
  } else {
    return _.chain(permissions)
      .map((permission) => {
        let [entityTypeId, entityId, role] = permission.split(':');
        const entityIdFromPermission = entityId.split('_')[0];
        const suborgIdFromPermission = entityId.split('_')[2];
        if (
          entityIdFromPermission == suborgIdFromPermission &&
          entityIdFromPermission == suborgId &&
          suborgIdFromPermission == suborgId &&
          entityTypeId == ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code &&
          role == roleId
        ) {
          return true;
        } else {
          return false;
        }
      })
      .filter((value) => value !== undefined && value === true)
      .uniq()
      .value()[0];
  }
};

/**
 * isFemaUser compares the entityId and checks whether it is fema or non fema
 * @param {[]} array
 * @return {boolean}
 */
export const isFemaUser = (permissions) => {
  const entityIds = retrieveAllEntityIdsFromPermissions(permissions);
  return (
    _.includes(entityIds, ENTITY_MAP.PROGRAM.code) ||
    _.includes(entityIds, ENTITY_MAP.REPORT_CATEGORY.code) ||
    _.includes(entityIds, ENTITY_MAP.FEMA_ORGANIZATION.code) ||
    _.includes(entityIds, ENTITY_MAP.FEMA_SYSTEM.code) ||
    _.includes(entityIds, ENTITY_MAP.FUNDING_OPPORTUNITY.code)
  );
};

export const isRecipientUser = (permissions) => {
  const entityIds = retrieveAllEntityIdsFromPermissions(permissions);
  const roleIds = retrieveRolesFromPermissions(permissions);
  const isRecipientEntityType =
    _.includes(entityIds, ENTITY_MAP.ORGANIZATION.code) ||
    _.includes(entityIds, ENTITY_MAP.PROGRAM_ORGANIZATION.code);
  if (isRecipientEntityType) {
    return (
      _.includes(roleIds, ROLE_MAP.ORGAOR.code) ||
      _.includes(roleIds, ROLE_MAP.ORGMEMBER.code) ||
      _.includes(roleIds, ROLE_MAP.ORGPGMMEMBER.code) ||
      _.includes(roleIds, ROLE_MAP.ORGFINMEMBER.code) ||
      _.includes(roleIds, ROLE_MAP.ORGGRNTWRITER.code)
    );
  } else {
    return false;
  }
};

export const isProgramExternal = (permissions) => {
  return _.includes(
    retrieveAllEntityIdsFromPermissions(permissions),
    ENTITY_MAP.PROGRAM_EXTERNAL.code
  );
};

export const isInternalReadOnly = (permissions, programId, fundingOpportunityId) => {
  if (_.isEmpty(permissions)) {
    return false;
  } else {
    const hasProgOrFoROrole =
      _.includes(
        permissions,
        `${ENTITY_MAP.PROGRAM.code}:${programId}:${ROLE_MAP.READONLY.code}`
      ) ||
      _.includes(
        permissions,
        `${ENTITY_MAP.FUNDING_OPPORTUNITY.code}:${fundingOpportunityId}:${ROLE_MAP.READONLY.code}`
      );

    const hasProgOrFoNonROrole =
      !!_.chain(permissions)
        .map((permission) => {
          const [entityTypeId, entityId, role] = _.split(permission, ':');
          return (
            role !== ROLE_MAP.READONLY.code &&
            ((entityTypeId === ENTITY_MAP.PROGRAM.code && entityId === `${programId}`) ||
              (entityTypeId === ENTITY_MAP.FUNDING_OPPORTUNITY.code &&
                entityId === `${fundingOpportunityId}`))
          );
        })
        .filter((result) => result)
        .value().length > 0;

    const isSmaOrSmuRole = isSmaOrSmu(permissions);

    return (hasProgOrFoROrole || isSmaOrSmuRole) && !hasProgOrFoNonROrole;
  }
};

export const isSmaOrSmu = (permissions) => {
  return (
    _.includes(permissions, `${ENTITY_MAP.FEMA_SYSTEM.code}:0:${ROLE_MAP.SMA.code}`) ||
    _.includes(permissions, `${ENTITY_MAP.FEMA_SYSTEM.code}:0:${ROLE_MAP.SMU.code}`)
  );
};

export const isFemaOrProgramExternal = (permissions) => {
  return isFemaUser(permissions) || isProgramExternal(permissions);
};

export const hasBankingPermissions = (permissions) => {
  const roles = retrieveRolesFromPermissions(permissions);
  // If at least one role is in permissions array:
  return _.difference(roles, BANKING_PERMISSION_ROLES).length !== roles.length;
};

export const getOrgIdFromCurrentLocation = (state) => {
  if (state.router.location.pathname) {
    return state.router.location.pathname.split('/').pop();
  }

  return '';
};

export const hasEntityRole = (state, role) => {
  let bool = false;
  if (state.auth.permissions === []) {
    return false;
  } else {
    _.forEach(state.auth.permissions, (permission) => {
      if (permission.match(role)) {
        bool = true;
        return false;
      }
    });
  }
  return bool;
};
export const countHiringOfFirefighterPaymentsGreaterThan = (paymentList) => {
  let newList = _.filter(paymentList, (payment) => {
    return payment.entityType === PAYMENT && payment.status === STATUS_PENDING_SUBMISSION;
  });
  return newList.length;
};

export const getTshirtSizeCol = (size) => {
  let width;
  switch (size) {
    case 'small':
      width = '5';
      break;
    case 'medium':
      width = '9';
      break;
    case 'large':
      width = '13';
      break;
    default:
      width = '16';
  }
  return width;
};

export const getTshirtSizePx = (size) => {
  let width;
  switch (size) {
    case 'xxsmall':
      width = '100px';
      break;
    case 'xsmall':
      width = '150px';
      break;
    case 'small':
      width = '200px';
      break;
    case 'medium':
      width = '300px';
      break;
    case 'large':
      width = '400px';
      break;
    default:
      width = '500px';
  }
  return width;
};

export const enhance = (c) => withGuidance(withValidation(c));
export const enhanceInline = (c) => withGuidance(withValidation(c, true, true));

// same as GET, but treats empty string as full object
export const getObjectFromPath = (obj, path) => {
  return path !== '' ? _.get(obj, path) : obj;
};

// for use in the dynamic framework only, not in individual components
// if you're thinking of using it in a component, you should probably be
// using the framework for dependency gathering
export const getDependencyFromState = (reduxState, path) => {
  const splitPath = _.split(path, '.');
  const root = _.get(splitPath, 0);
  // places that you can have as dependencies outside dynamicComponent { 'myProp': 'profile.a.b' }
  const ALLOWED_OTHER_ROOTS = ['profile'];

  if (_.includes(ALLOWED_OTHER_ROOTS, root)) {
    return getObjectFromPath(reduxState, path);
  } else {
    return getObjectFromPath(_.get(reduxState, 'dynamicComponent'), path);
  }
};

export const checkForIE = () => {
  if (
    navigator.appVersion.indexOf('MSIE 10') !== -1 ||
    navigator.userAgent.indexOf('Trident/7.0') !== -1
  ) {
    return true;
  }
  return false;
};

export const convertToDate = (value) => {
  if (value) {
    value = moment(value);
  }
  return value;
};

export const convertDateMMDDYYYY = (value) => {
  if (value) {
    let length = value.length;
    if (length === 10 && /^\d{4}-\d{2}-\d{2}/.test(value) && checkForIE()) {
      value = moment(value).format('MM/DD/YYYY');
    }
  }

  return value;
};

export const convertDateForDisplay = (value, inMilli) => {
  if (value) {
    if (inMilli || /^\d{4}-\d{2}-\d{2}/.test(value)) {
      if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
        value = value.substring(0, 10);
      }
      value = moment(value).format('MM/DD/YYYY');
    }
  }
  return value;
};
export const convertUTCDateToLocalDateDisplay = (value, inMilli) => {
  let newValue = value;
  if (value && (inMilli || /^\d{4}-\d{2}-\d{2}/.test(value))) {
    if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
      newValue = new Date(value.substring(0, 16));
      newValue = new Date(newValue.getTime() - newValue.getTimezoneOffset() * 60 * 1000);
    }
    newValue = moment(newValue).format('MM/DD/YYYY');
  }
  return newValue;
};

export const convertDateYYYYMMDD = (value) => {
  if (value) {
    if (/^\d{1,2}\/\d{1,2}\/\d{4}/.test(value) && checkForIE()) {
      value = moment(value).format('YYYY-MM-DD');
    }
  }

  return value;
};

export const validDate = (value, format) => {
  return moment(value, format, true).isValid();
};

export const toSysDate = (date) => {
  const result = moment(date, 'MM/DD/YYYY', true);
  if (!result.isValid()) {
    return date;
  }
  return result.format('YYYY-MM-DD');
};

export const toDisplayDate = (date) => {
  const result = moment(date, 'YYYY-MM-DD', true);
  if (!result.isValid()) {
    return date;
  }
  return result.format('MM/DD/YYYY');
};

export const CurrentYear = (addOrSubtract) => {
  return safeAdd(new Date().getFullYear(), addOrSubtract);
};

export const SumOfJsonPathArray = (data, jsonPathPattern, arrayIndex) => {
  let sum = 0;
  _.forEach(JSONPath.nodes(data, jsonPathPattern), (node) => {
    let array = node.value;
    if (array && array.length > arrayIndex && !_.isNaN(_.toNumber(array[arrayIndex]))) {
      sum += _.toNumber(array[arrayIndex]);
    }
  });
  return sum;
};

export const ISOToDisplayDate = (value, config = {}) => {
  const {
    showHours,
    showDate,
    showTimeZone,
    describeMonth,
    useUserTimezone,
    twentyFour,
    ISOString,
    strictFormattingString,
  } = config;
  if (value) {
    const normalizedValue = normalizeDateValue(value);
    let zone = useUserTimezone ? moment.tz.guess() : MOMENT_EST;
    if (ISOString) {
      value = moment(normalizedValue).format();
    } else {
      let dateString = describeMonth
        ? `MMMM DD, YYYY${showHours ? ',' : ''}`
        : 'MM/DD/YYYY';
      let hourString = twentyFour ? 'H:mm' : 'h:mm a';
      let z = showHours && showTimeZone ? ' z' : '';
      let hr = showHours ? hourString : '';
      let dt = showDate ? dateString : '';
      let delimiter = dt && hr ? ' ' : '';
      let result;
      if (!!strictFormattingString) {
        result = moment.tz(normalizedValue, strictFormattingString, true, zone);
      } else {
        result = moment.tz(normalizedValue, zone);
      }
      if (result.isValid()) {
        value = result.format(dt + delimiter + hr + z);
      }
    }
  }
  return value;
};

export const addMonthsToDate = (
  date,
  months,
  format = 'YYYY-MM-DD',
  strictFormatting = false
) => {
  // strictformatting enforces that provided date should be in the valid format
  // Without strictFormatting, inputs like "0" and "12/02/1" will still return a date
  if (strictFormatting && !moment(date, format, true).isValid()) return 'Invalid date';

  const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/\d{4}$/;
  let formattedDate = date;
  if (regex.test(date)) {
    const [month, day, year] = date.split('/');
    formattedDate = `${year}-${month}-${day}`;
  }
  const value = moment.tz(formattedDate, MOMENT_EST).add(months, 'month');
  return value.format(format);
};

export const addDaysToDate = (date, days, format = 'YYYY-MM-DD') => {
  const value = moment.tz(date, MOMENT_EST).add(days, 'd');
  return value.format(format);
};

export const getDate = (year, month, day) => {
  const dateInTimezone = moment.tz([year, month - 1, day], MOMENT_EST);
  return dateInTimezone.format('YYYY-MM-DD');
};

export const getTimestampOfISO = (value) => {
  return moment(value).toISOString();
};
export const getTimestampNowISO = () => {
  return moment.tz(moment.tz.guess() || MOMENT_EST).format();
};

export const getUnixtimeFromISO = (value) => moment(value).unix();

const normalizeDateValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  // Date object
  if (value instanceof Date) {
    return value;
  }

  // Number, likely Unix seconds or milliseconds
  if (typeof value === 'number') {
    // Unix seconds are usually 10 digits.
    // Unix milliseconds are usually 13 digits.
    return value < 10000000000 ? value * 1000 : value;
  }

  // Numeric string, likely Unix seconds or milliseconds
  if (typeof value === 'string' && /^\d+$/.test(value.trim())) {
    const numericValue = Number(value.trim());

    return numericValue < 10000000000 ? numericValue * 1000 : numericValue;
  }

  // Otherwise assume ISO or another date string Moment can parse
  return value;
};

export const secondsFromEpochToDisplayDate = (value, showHours) => {
  if (value) {
    value = value * 1000;
    if (showHours) {
      value = moment.tz(value, MOMENT_EST).format('MM/DD/YYYY h:mm a');
    } else {
      value = moment(value).format('MM/DD/YYYY');
    }
  }
  return value;
};
export const getPercentage = (remainder, target) => {
  if (remainder != null && target != null) {
    return ((remainder / target) * 100).toFixed(0) + '%';
  }

  return null;
};
export const convertValueToPercent = (value) => {
  if (value) {
    value = parseFloat(value).toFixed(2) + ' %';
  } else {
    value = '000.00 %';
  }
  return value;
};

export const checkIfValuesAre = (array, value) => {
  for (let a of array) {
    if (_.isEqual(a, value)) {
      return true;
    }
  }
  return false;
};

export const checkIfDefinedNonNullAndNotEmptyString = (value) => {
  return !checkIfValuesAre([null, undefined, ''], value);
};

export const toTitleCase = (str) => {
  return _.map(_.split(_.toLower(str), /\s+/g), _.upperFirst).join(' ');
};

const LABEL_MAPPINGS = {
  nationalstateregional: 'National/State/Regional Programs and Studies',
  sprinklerawarness: 'Sprinkler Awareness',
  generalprevention: 'General Prevention/Awareness',
  wildlandfireprevention: 'Wildland Fire Prevention Programs',
  riskassessments: 'Risk Assessments',
  juvenilefiresetter: 'Juvenile Firesetter Program',
  smokealarmcampaign: 'Smoke Alarm Campaign',
  publiceducation: 'Public Education',
  publiceducation2: 'Public Education 2',
  codeenforcementawareness: 'Code Enforcement/Awareness',
  firearsoninvestigation: 'Fire & Arson Investigation',
  firefightersafety: 'Firefighter Safety',
  other: 'Other',
  other2: 'Other 2',
  other3: 'Other 3',
  othercrr: 'Other Community Risk Reduction',
  othernational: 'Other National/State/Regional',
  adoptionawareness: 'Adoption or Awareness',
  wuieducationprogram: 'WUI Education and Awareness',
  wuieducationprogramwoodchipper:
    'WUI Education and Awareness including Wood Chipper Program',
};

export const camelCaseToSpaces = (str) => {
  if (LABEL_MAPPINGS[str] !== undefined) {
    return LABEL_MAPPINGS[str];
  }

  //known edge cases:
  switch (str) {
    case 'ppe':
      return 'PPE';
      break;
    case 'wellness':
      return 'Wellness and Fitness';
      break;
    case 'vehicle':
      return 'Vehicle Program';
      break;
    case 'modifyfacilities':
      return 'Modify Facilities';
      break;
    case 'equipment':
      return 'Equipment';
      break;
    case 'training':
      return 'Training';
      break;
    case 'fireandarsoninvestigation':
      return 'Fire & Arson Investigation';
      break;
    case 'programsandstudies':
      return 'National/State/Regional Programs and Studies';
      break;
    case 'communityriskreduction':
      return 'Community Risk Reduction';
      break;
    case 'hiringfirefighters':
      return 'Hiring of Firefighters';
      break;
    case 'recruitment':
      return 'Recruitment and Retention of Volunteer Firefighters';
      break;
    case 'researchanddevelopment':
      return 'Research and Development';
      break;
    case 'submittedToFEMA':
      return 'Submitted to FEMA';
      break;
    case undefined:
      return null;
      break;
  }

  const result = str.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const checkIfEmailIsPivFEMA = (email) => {
  const femaEmails = ['@dhs.gov'];
  for (var i = 0; i < femaEmails.length; i++) {
    if (email.endsWith(femaEmails[i])) {
      return true;
    }
  }
  return false;
};

export const checkIfEmailIsFEMA = (email) => {
  const femaEmails = [
    '@fema.dhs.gov',
    '@associates.fema.dhs.gov',
    '@dhs.gov',
    '@fema.gov',
    '@hq.dhs.gov',
    '@cbp.dhs.gov',
    '@associates.cisa.dhs.gov',
    '@cisa.dhs.gov',
    '@uscg.mil',
    '@associates.tsa.dhs.gov',
    '@tsa.dhs.gov',
    '@dot.gov',
  ];
  for (var i = 0; i < femaEmails.length; i++) {
    if (email.indexOf(femaEmails[i]) !== -1) {
      return true;
    }
  }
  return false;
};

export const checkIfEmailIsValid = (value) => {
  let isvalid = false;
  if (value != null && value != undefined && value.match(email_regex)) {
    isvalid = true;
  }
  return isvalid;
};

export const safeDivide = (...values) => {
  let valueList = [...values];
  let checkIfNum = (val) => {
    return !isNaN(parseFloat(val));
  };
  if (valueList.length === 0 || !_.every(valueList, checkIfNum)) {
    return null;
  } else {
    valueList = _.map(valueList, (value) => {
      return parseFloat(value);
    });
    let result = bignumber(valueList.shift());
    for (let value of valueList) {
      result = divide(result, bignumber(value));
    }
    if (!isFinite(result)) {
      return 0;
    } else {
      return number(result);
    }
  }
};
export const safeSubstract = (...values) => {
  let valueList = [...values];
  const first = valueList.shift();
  return safeAdd(first, ..._.map(valueList, (value) => -value));
};

// Same as safeSubstract but calls safeAddNoFixed
export const safeSubstractNoFixed = (...values) => {
  let valueList = [...values];
  const first = valueList.shift();
  return safeAddNoFixed(first, ..._.map(valueList, (value) => -value));
};

export const safeMult = (...values) => {
  let valueList = [...values];
  let checkIfNum = (val) => {
    return !isNaN(parseFloat(val));
  };
  if (valueList.length === 0 || !_.every(valueList, checkIfNum)) {
    return null;
  } else {
    valueList = _.map(valueList, (value) => {
      return parseFloat(value);
    });
    let result = bignumber(valueList.pop());
    for (let value of valueList) {
      result = multiply(bignumber(value), result);
    }
    return number(result);
  }
};
export const safeAdd = (...values) => {
  let valueList = [...values];
  valueList = _.map(valueList, (value) =>
    !value || isNaN(value) ? 0 : parseFloat(value)
  );
  let result = 0;
  valueList.forEach((value) => (result += value));
  return parseFloat(result.toFixed(2));
};

// Same as safeAdd but does not return negative value (if negative return zero)
export const safeAddReturnNonNegative = (...values) => {
  let valueList = [...values];
  const zeroValue = 0;
  valueList = _.map(valueList, (value) =>
    !value || isNaN(value) ? 0 : parseFloat(value)
  );
  let result = 0;
  valueList.forEach((value) => (result += value));
  const returnValue = parseFloat(result.toFixed(2));
  return returnValue >= 0 ? returnValue : zeroValue;
};

// Same as safeAdd but does not format a number using fixed-point notation
export const safeAddNoFixed = (...values) => {
  // JavaScript uses IEEE-754 double precision float point with precision of about 15 to 17 decimal places.
  // Due to how floating-point numbers are represented in binary, certain fractions (like 0.1 or 0.2) cannot be stored with perfect precision,
  // leading to small rounding errors (e.g., 0.1 + 0.2 might result in 0.30000000000000004 instead of 0.3)
  // Catastrophic cancellation is a phenomenon in numerical analysis where the subtraction of two nearly equal,
  // large numbers results in a massive loss of precision.
  // Ex: 33809.51 + 0.01 = 33809.520000000004
  // 33809.52 - 33809.520000000004 = -7.2759576141834e-12 (Catastrophic cancellation)
  // MathJS provides a BigNumber type that supports arbitrary precision,
  // which can prevent the rounding errors that lead to catastrophic cancellation.
  // bignumber(33809.51) + bignumber(0.01)
  // 33809.52

  let result = bignumber(0);
  values.forEach((value) => {
    const val = bignumber(value || 0);
    result = add(result, val);
  });
  return result.toNumber();
};

export const safeAddReduce = (valueList, base) => {
  return _.reduce(
    valueList,
    (currTotal, value) => {
      return safeAdd(currTotal, value);
    },
    base
  );
};

export const hasChildren = (obj) => {
  return obj.children !== undefined && !_.isEmpty(obj.children);
};

export const isStringEmpty = (text) => {
  if (_.isString(text)) {
    text = text.replace(/ /g, '');
    text = text.replace(/\t/g, '');
    text = text.replace(/\n/g, '');
  }
  if (text === '') {
    return true;
  }
  return false;
};

// preemptively listing more filetypes than we support
// to avoid later work since this is just for icon displaying
export const iconFromExtension = (type) => {
  let lowercaseType = type.toLowerCase();
  const namePrefix = 'file ';
  let name;
  let color;
  switch (lowercaseType) {
    case 'pdf':
      name = 'pdf';
      color = 'red';
      break;
    case 'doc':
    case 'docx':
      name = 'word';
      color = 'blue';
      break;
    case 'xls':
    case 'xlsx':
      name = 'excel';
      color = 'green';
      break;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      name = 'image';
      color = 'black';
      break;
    case 'ppt':
    case 'pptx':
      name = 'powerpoint';
      color = 'red';
      break;
    default:
      name = 'alternate';
      color = 'grey';
  }
  return {
    name: namePrefix + name,
    color,
  };
};

export const getExtension = (fileName) => {
  let fileNameParts = fileName.split('.');
  // Assuming we want empty string if the name has no extension
  let extension = fileNameParts.length > 1 ? fileNameParts.pop() : '';
  return extension;
};

export const getNumberFromObject = (obj, path) => {
  let value = _.get(obj, path, 0);
  if (!_.isNumber(value)) {
    value = 0;
  }
  return value;
};

export const requestDetailsChangesToDisplayString = (change, index) => {
  const {type} = change;
  let message = <span />;
  const formatValue = (value, formatType) => {
    const valueOrDefault = value !== undefined ? value : '';
    return (
      <strong>
        {formatType === 'dollar'
          ? `${formatDollarOrEmptyString(valueOrDefault)}`
          : valueOrDefault}
      </strong>
    );
  };

  switch (type) {
    case REQUEST_DETAILS_CHANGES_TYPES.VALUE_CHANGE:
      const prev = formatValue(change.previousValue, change.formatType);
      const curr = formatValue(change.currValue, change.formatType);
      message = (
        <span>
          <strong>{REQUEST_DETAILS_VALUE_CHANGE_DISPLAY[change.field]}</strong>
          {' from '}
          {prev}
          {' to '}
          {curr}
        </span>
      );
      break;
    case REQUEST_DETAILS_CHANGES_TYPES.INELIGIBLE_CHANGE:
      message = (
        <span>
          <strong>Line item</strong>
          {' marked '}
          <strong>{change.becameIneligible ? 'ineligible' : 'eligible'}</strong>
        </span>
      );
      break;
    case REQUEST_DETAILS_CHANGES_TYPES.NEWLY_CREATED:
      message = <strong>Line item created</strong>;
      break;
    case REQUEST_DETAILS_CHANGES_TYPES.VALUE_CHANGE_NO_DISPLAY:
      message = (
        <strong>
          {REQUEST_DETAILS_VALUE_CHANGE_DISPLAY[change.field]}
          {' changed'}
        </strong>
      );
      break;
    default:
      break;
  }

  return message;
};

export const isToggledOnDependency = (toggle, toggleList, entityType, entityId) => {
  return toggle
    ? _.find(toggleList, (curr) => {
        return matchesToggle(toggle, curr, entityType, entityId);
      }) !== undefined
    : true;
};

export const countDependenciesToLoad = (
  dependencies,
  isFema,
  toggles,
  entityType,
  entityId
) => {
  let count = 0;
  _.forEach(dependencies, (dependency) => {
    const dependencyToggle = _.get(dependency, 'dependencyConfig.toggle.name', false);
    const isToggledOnDependencyFlag = isToggledOnDependency(
      dependencyToggle,
      toggles,
      entityType,
      entityId
    );
    // this also needs another condition for negated toggles e.g. "ifNot". Maybe like dependencyConfig.toggleIfNot
    if (isToggledOnDependencyFlag) {
      if (_.get(dependency, 'dependencyConfig.femaPermissionsOnly')) {
        if (isFema && !dependency.optional) {
          count += 1;
        }
      } else if (!dependency.optional) {
        count += 1;
      }
    }
  });
  return count;
};

export const calculatePaymentDispursements = (data) => {
  let fedTotal = 0;
  let pendingTotal = 0;
  let totals = [];
  _.forEach(data, (payment) => {
    if (payment.payload != undefined) {
      if (payment.status === 'approved') {
        fedTotal = safeAdd(payment.payload.amount, fedTotal);
      }
      if (payment.status === 'submittedToFEMA') {
        pendingTotal = safeAdd(payment.payload.amount, pendingTotal);
      }
    }
  });
  totals.federalDispursements = fedTotal;
  totals.pendingDispursements = pendingTotal;

  return totals;
};

export const calculatePaymentDispursementsForSubGrants = (data, subGrantId) => {
  let fedTotal = 0;
  let pendingTotal = 0;
  let totals = {};
  _.forEach(data, (payment) => {
    if (payment.payload != undefined && payment.subGrantId === subGrantId) {
      if (payment.status === 'approved') {
        fedTotal = safeAdd(payment.payload.amount, fedTotal);
      }
      if (payment.status === 'submittedToFEMA') {
        pendingTotal = safeAdd(payment.payload.amount, pendingTotal);
      }
    }
  });
  totals.federalDispursements = fedTotal;
  totals.pendingDispursements = pendingTotal;

  return totals;
};

export const calculateCloseoutCashDisbursements = (data, calcFedShare) => {
  const totalAmount = data.payload.reduce((sum, current) => {
    var totalShare = calcFedShare
      ? getTotalShare(current.payload.budget.share.actualFedShare)
      : getTotalShare(current.payload.budget.share.actualAppShare);
    return safeAdd(sum, totalShare);
  }, 0);

  return totalAmount;
};

export const calculateRecipientShareOfExpenditures = (data) => {
  const totalAmount = data.payload.reduce((sum, current) => {
    return safeAdd(sum, current.payload.budget.actualAllowedTotalAmount);
  }, 0);
  return totalAmount;
};

const getTotalShare = (share) => {
  var totalActualFedShare = share
    .map(Number)
    .reduce((sum, current) => safeAdd(sum + current), 0);
  return totalActualFedShare;
};

export const calculateSF425Totals = (data) => {
  let baseTotal = 0;
  let amountChargedTotal = 0;
  let federalShareTotal = 0;
  let totals = [];
  _.forEach(data, (row) => {
    baseTotal = safeAdd(row.base, baseTotal);
    amountChargedTotal = safeAdd(
      (row.indirectCostRate / 100) * row.base,
      amountChargedTotal
    );
    federalShareTotal = safeAdd(row.federalShare, federalShareTotal);
  });
  totals.base = baseTotal;
  totals.amountCharged = amountChargedTotal;
  totals.federalShare = federalShareTotal;
  return totals;
};

export const calculatePaymentFederalBalance = (data, fedShare) => {
  let fedDispursements = 0;
  let pendingDispursements = 0;
  let totalFedAvail = 0;
  let fedResourcesAwarded = 0;

  if (typeof fedShare === 'object') {
    fedResourcesAwarded = safeAdd(...fedShare);
  } else {
    fedResourcesAwarded = _.toNumber(fedShare);
  }

  if (data != undefined) {
    fedDispursements = calculatePaymentDispursements(data).federalDispursements;
    pendingDispursements = calculatePaymentDispursements(data).pendingDispursements;
    totalFedAvail = safeSubstractNoFixed(
      fedResourcesAwarded,
      safeAddNoFixed(fedDispursements, pendingDispursements)
    );
  }

  return totalFedAvail;
};

export const calculateBOCAggregates = (data, bocList) => {
  let totals = _.map(bocList, (boc) => ({
    boc: boc,
    total: 0,
  }));
  _.forEach(data.preAwardCosts, (cost) => {
    const costBoc = cost.boc;
    const matchIndex = _.findIndex(totals, ['boc', costBoc]);
    if (matchIndex >= 0 && !cost.ineligible) {
      _.set(
        totals,
        [matchIndex, 'total'],
        safeAdd(
          _.get(totals, [matchIndex, 'total'], 0),
          safeMult(cost.price * cost.quantity)
        )
      );
    }
  });
  _.forEach(data.activityItems, (firstTier) => {
    const additional = _.get(firstTier, 'additionalRequests');
    const children = _.get(firstTier, 'children');
    _.forEach(additional, (funding) => {
      const fundingBoc = funding.boc;
      const matchIndex = _.findIndex(totals, ['boc', fundingBoc]);
      if (matchIndex >= 0 && !funding.ineligible) {
        _.set(
          totals,
          [matchIndex, 'total'],
          safeAdd(_.get(totals, [matchIndex, 'total'], 0), funding.amount)
        );
      }
    });
    _.forEach(children, (secondTier) => {
      const secondBoc = secondTier.boc;
      const matchIndex = _.findIndex(totals, ['boc', secondBoc]);
      if (matchIndex >= 0 && !secondTier.ineligible) {
        _.set(
          totals,
          [matchIndex, 'total'],
          safeAdd(
            _.get(totals, [matchIndex, 'total'], 0),
            safeMult(secondTier.price, secondTier.quantity)
          )
        );
      }
      _.forEach(secondTier.children, (thirdTier) => {
        const thirdBoc = thirdTier.boc;
        const thirdMatchIndex = _.findIndex(totals, ['boc', thirdBoc]);
        if (thirdMatchIndex >= 0 && !thirdTier.ineligible) {
          _.set(
            totals,
            [thirdMatchIndex, 'total'],
            safeAdd(
              _.get(totals, [thirdMatchIndex, 'total'], 0),
              safeMult(thirdTier.price, thirdTier.quantity)
            )
          );
        }
      });
    });
  });
  let totalsTotal = 0;
  totals = _.map(totals, (bocTotal) => {
    bocTotal.boc = toStartCase(bocTotal.boc);
    totalsTotal += bocTotal.total;
    return `${bocTotal.boc}-${bocTotal.total}`;
  });

  totals.push(`Total-${totalsTotal}`);
  return totals;
};

// lodash startCase removes special characters such as parenthesis
export const toStartCase = (text) => {
  if (!checkIfValuesAre(['', null, undefined], text)) {
    return text.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1);
    });
  }
  return text;
};

//convert only first char to upper case without removing special characters
export const firstCharToUpperCase = (text) => {
  const CUSTOM_MAPPING = {
    'additional attachment (general attachments)':
      'Additional attachment (General attachments)',
  };

  if (CUSTOM_MAPPING[text] !== undefined) {
    return CUSTOM_MAPPING[text];
  }

  return _.upperFirst(text);
};

export const formatDollarOrEmptyString = (value) => {
  return value !== undefined ? showDollarAmountWithDollar(value) : '';
};

export const addBusinessDays = (value, numberOfDays) => {
  momentBusinessDays.updateLocale('us', {
    holidays: HOLIDAYS,
    holidayFormat: 'MM-DD-YYYY',
  });
  const addedDate = momentBusinessDays(value).businessAdd(numberOfDays).format();

  return addedDate;
};

export const setTime = (date, hours, minutes) => {
  const momentDate = moment(date)
    .hour(hours || 0)
    .minute(minutes || 0);
  return momentDate.format();
};

export const compileContent = (content, ctx, parseHtml, templateAsArray) => {
  let compiledContent = content;
  try {
    // Only compile when need to
    if (
      typeof content === 'string' &&
      (content.indexOf('<%') > -1 || content.indexOf('${') > -1 || parseHtml)
    ) {
      // merge our utility function context with the variables provided by the component
      let newCtx = {
        ...ctx,
        ...TEMPLATE_CONTEXT,
      };
      compiledContent = _.template(content)(newCtx);
      if (templateAsArray) {
        compiledContent = compiledContent.split(templateAsArray);
      }
      if (parseHtml) {
        // we don't want to do this generally, just when safe to avoid rendering
        // user input as HTML
        compiledContent = ReactHtmlParser(compiledContent);
      }
    }
  } catch (err) {
    if (content !== SUB_AWARD_REC_INDX_ERROR) {
      console.error(err);
    }
    compiledContent = '';
  }
  return compiledContent;
};

const PHONE_TYPE_OPTIONS = {
  1: 'Alternate',
  2: 'Car',
  3: 'Work Fax',
  4: 'Home',
  5: 'Lodging',
  6: 'Mobile',
  7: 'Other',
  8: 'Pager',
  9: 'Receptionist',
  10: 'Work',
  11: 'Home Fax',
  12: 'Lodging Fax',
};

export const newlyAddedDisasterLocationNames = (options, prevDate) => {
  if (options && prevDate) {
    const filterOptions = _.filter(options, function (item) {
      return moment(item.entryDt, 'YYYY-MM-DD').isAfter(moment(prevDate));
    });
    const optionStrings = _.map(filterOptions, (item) => item.placeNm);
    return _.join(optionStrings);
  }
  return '';
};

export const gatherPhoneList = (inPhoneList) => {
  let outPhonesList = [];
  outPhonesList = _.map(inPhoneList, (phone) => ({
    phoneType: PHONE_TYPE_OPTIONS[phone.phoneType]
      ? PHONE_TYPE_OPTIONS[phone.phoneType]
      : 'Unknown',
    phoneNumber: displayPhoneNumber(phone.areaCode, phone.phoneNumber),
    phoneExt: phone.phoneExtension,
  }));
  return outPhonesList;
};

export const countCommentsAndAttachments = (payload) => {
  var commentCount = 0;
  var attachmentCount = 0;
  var commentString = 'comment';
  var attachmentString = 'attachment';
  JSON.stringify(payload, (key, value) => {
    if (key === 'additionalComments') commentCount++;
    if (key === 'attachmentIds') attachmentCount += value.length;
    return value;
  });

  commentString += commentCount !== 1 ? 's' : '';
  attachmentString += attachmentCount !== 1 ? 's' : '';

  return `${commentCount} ${commentString}, ${attachmentCount} ${attachmentString}`;
};

export const getSumFirstNonNullKeyInObject = (allOrgsData, keys) => {
  if (!allOrgsData || typeof allOrgsData !== 'object') return 0;
  return Object.values(allOrgsData).reduce((totalSum, {lockInAmounts}) => {
    const value = getFirstNonNullKeyInObject(lockInAmounts, LOCKIN_TIMEFRAME)?.[keys];
    const numericValue = Number(value);
    return totalSum + (isNaN(numericValue) ? 0 : numericValue);
  }, 0);
};

export const getFirstNonNullKeyInObject = (payload, keys) => {
  for (let key of keys) {
    if (payload[key]) {
      return payload[key];
    }
  }
  return {};
};

export const getFirstNonNullKeyNameInObject = (payload, keys) => {
  for (let key of keys) {
    if (payload[key]) {
      return key;
    }
  }
  return null;
};

const filterDataByEntityType = (data, entityType, filterForSRMC = false) => {
  return _.filter(data, (obj) => {
    return (
      obj.entityType === entityType &&
      (!filterForSRMC || obj.payload.applicationType !== '233')
    );
  });
};

export const getSRMCTarget = (lockInAmounts = {}, federalShareCostSharePrimeAward) => {
  const projectFundsObligationLimit = getFirstNonNullKeyInObject(
    lockInAmounts,
    LOCKIN_TIMEFRAME
  )['projectFundsObligationLimit']
    ? getFirstNonNullKeyInObject(lockInAmounts, LOCKIN_TIMEFRAME)[
        'projectFundsObligationLimit'
      ]
    : 0;
  // We have two entry points for the federalShareCostSharePrimeAward value, one that enters a whole number and one that enters decimals.
  // Want to make sure we are doing the calculation with a decimal version
  // If federalShareCostSharePrimeAward is blank/undefined we just return 0.00 instead of trying to divide by 0
  if (!federalShareCostSharePrimeAward) {
    return 0;
  }

  let convertedFedCostShare = _.toNumber(federalShareCostSharePrimeAward);
  let consumedFederalShareCostSharePrimeAward =
    convertedFedCostShare <= 1 ? convertedFedCostShare : convertedFedCostShare / 100;

  return (
    0.05 *
    (_.toNumber(projectFundsObligationLimit) / consumedFederalShareCostSharePrimeAward)
  );
};

export const getSRMCTargetAllRecipients = (
  allOrgData = [],
  federalShareCostSharePrimeAward
) => {
  let srmcTarget = _.reduce(
    allOrgData,
    (total, orgData) => {
      let lockInAmounts = _.get(orgData, 'lockInAmounts', null);
      let value = getSRMCTarget(lockInAmounts, federalShareCostSharePrimeAward);
      let totalValue = parseFloat(formatDollarDecimals(value.toString()));
      return safeAddNoFixed(total, totalValue);
    },
    0
  );

  return srmcTarget;
};

export const getSRMCRemainingAmountsAllRecipients = (
  allOrgData = {},
  recipientTargetEntities,
  federalShareCostSharePrimeAward,
  isProjected
) => {
  let remainingAmounts = _.reduce(
    Object.keys(allOrgData),
    (total, orgId) => {
      if (_.isEmpty(allOrgData[orgId])) {
        return safeAdd(total, 0);
      }
      let lockInAmounts = _.get(allOrgData[orgId], 'lockInAmounts', null);
      let srmcTarget = getSRMCTarget(lockInAmounts, federalShareCostSharePrimeAward);
      let targetEntities = _.filter(
        recipientTargetEntities,
        (entity) => entity.organizationId == orgId
      );
      let totalAmounts = isProjected
        ? getSRMCProjected(targetEntities)
        : getSRMCObligation(targetEntities);
      let remAnount = srmcTarget - totalAmounts;
      let truncRemAmount = parseFloat(formatDollarDecimals(remAnount.toString()));
      return safeAdd(total, truncRemAmount);
    },
    0
  );

  return remainingAmounts;
};

export const getSRMCObligation = (recipientTargetEntities) => {
  const subAmendmentRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAmendmentRecommendation',
    true
  );
  const subAwardRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAwardRecommendation',
    true
  );

  const managementCosts = calculateManagementCostObligations(
    subAmendmentRecommendations,
    subAwardRecommendations,
    false
  );

  return managementCosts;
};

export const getSRMCProjected = (recipientTargetEntities) => {
  const subAmendmentRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAmendmentRecommendation',
    true
  );
  const subAwardRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAwardRecommendation',
    true
  );

  const managementCosts = calculateManagementCostObligations(
    subAmendmentRecommendations,
    subAwardRecommendations,
    true
  );

  return managementCosts;
};
export const calculateTotalPercentByFCAndObligationLimit = (
  data,
  calculateAgainstKey
) => {
  return _.chain(data)
    .map((item) => _.get(item, `${calculateAgainstKey}.targetPercent`, 0))
    .map(parseFloat)
    .sum()
    .value();
};

export const getSumByFundingCategoryTargetAmount = (
  allOrgsData,
  calculateAgainst,
  fundingCategoryTargetIndex,
  foOrgList
) => {
  let totalSum = 0;
  if (typeof fundingCategoryTargetIndex === 'string') {
    fundingCategoryTargetIndex = _.split(
      _.replace(fundingCategoryTargetIndex, /[\[\]']+/g, ''),
      ','
    );
  }
  if (allOrgsData && typeof allOrgsData === 'object') {
    Object.keys(allOrgsData).forEach((org) => {
      const {lockInAmounts, fundingCategoryTargets} = allOrgsData[org];

      if (fundingCategoryTargets) {
        fundingCategoryTargetIndex.forEach((index) => {
          if (fundingCategoryTargets[index]) {
            const {
              targetPercent,
              calculateAgainst: categoryCalculateAgainst,
            } = fundingCategoryTargets[index];
            if (categoryCalculateAgainst === calculateAgainst) {
              totalSum += getFundingCategoryTargetAmount(
                lockInAmounts,
                targetPercent,
                calculateAgainst
              );
            }
          }
        });
      }
    });
  }
  return totalSum;
};

export const getSumTotalObligationsOrProjectedByFoCategory = (
  allOrgsData,
  calculateAgainst,
  fundingCategoryTargetIndex,
  allRecipientTargetEntities,
  fundingCategory,
  foConfigData = [],
  fundingCategoryTargetsList = [],
  obligationLimitType,
  foOrgList,
  type
) => {
  let totalSum = 0;
  if (typeof fundingCategoryTargetIndex === 'string') {
    fundingCategoryTargetIndex = _.split(
      _.replace(fundingCategoryTargetIndex, /[\[\]']+/g, ''),
      ','
    );
  }
  if (allOrgsData && typeof allOrgsData === 'object') {
    Object.keys(foOrgList).forEach((key) => {
      const orgId = foOrgList[key];
      const recipientData = allRecipientTargetEntities.filter(
        (entity) => entity.organizationId === String(orgId)
      );

      const orgData = allOrgsData[String(orgId)];
      const fundingCategoryTargets = orgData?.fundingCategoryTargets;

      if (fundingCategoryTargets) {
        fundingCategoryTargetIndex.forEach((index) => {
          if (fundingCategoryTargets[index]) {
            const {calculateAgainst: categoryCalculateAgainst} = fundingCategoryTargets[
              index
            ];
            if (categoryCalculateAgainst === calculateAgainst) {
              if (_.isEqual(type, 'obligation')) {
                const orgTotal = getTotalObligations(
                  foConfigData[index].name,
                  recipientData
                );
                totalSum += orgTotal;
              } else if (_.isEqual(type, 'projected')) {
                const orgTotal = getTotalProjected(
                  foConfigData[index].name,
                  recipientData
                );
                totalSum += orgTotal;
              }
            }
          }
        });
      }
    });
  }
  return totalSum;
};

export const getTotalObligations = (
  fundingCategory,
  recipientTargetEntities,
  foConfigData = [],
  fundingCategoryTargets = [],
  obligationLimitType
) => {
  const subGrants = filterDataByEntityType(recipientTargetEntities, 'subGrant');
  const subAmendmentRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAmendmentRecommendation'
  );
  const subAwardRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAwardRecommendation'
  );

  const filteredFC = [];
  _.forEach(fundingCategoryTargets, (fc, idx) => {
    if (fc.calculateAgainst == obligationLimitType) {
      filteredFC.push(foConfigData[idx].name);
    }
  });

  const validSubGrants = obligationLimitType
    ? subGrants.filter((subGrant) => {
        return filteredFC.includes(subGrant.payload.fundingCategory);
      })
    : subGrants.filter(
        (subGrant) => subGrant.payload.fundingCategory === fundingCategory
      );

  const obligations = calculateObligations(
    validSubGrants,
    subAmendmentRecommendations,
    subAwardRecommendations,
    false
  );

  return obligations;
};

export const getTotalProjected = (fundingCategory, recipientTargetEntities) => {
  const subAmendmentRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAmendmentRecommendation'
  );
  const subAwardRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAwardRecommendation'
  );

  const matchedEntities = filterEntityByFundingCategory(
    subAwardRecommendations,
    fundingCategory
  );

  const obligations = calculateObligations(
    matchedEntities,
    subAmendmentRecommendations,
    subAwardRecommendations,
    true
  );
  return obligations;
};

export const getTotalProjectedByLimitType = (
  limitType,
  fundingCategories = [],
  fundingCategoryTargets = {},
  recipientTargetEntities
) => {
  const subAmendmentRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAmendmentRecommendation'
  );
  const subAwardRecommendations = filterDataByEntityType(
    recipientTargetEntities,
    'subAwardRecommendation'
  );

  const matchedEntities = filterEntityByLimitType(
    subAwardRecommendations,
    limitType,
    fundingCategories,
    fundingCategoryTargets
  );
  const obligations = calculateObligations(
    matchedEntities,
    subAmendmentRecommendations,
    subAwardRecommendations,
    true
  );
  return obligations;
};

export const LOCKIN_TIMEFRAME = ['recalculation', '12_months', '6_months', '30_days'];

export const getLoadedEntities = (entities) => {
  return entities ? Object.values(_.omit(entities, 'loading')) : [];
};

export const mapFundingCategoryTargetByName = (
  fundingCategories,
  fundingCategoryTargets
) => {
  const nameToIndexMap = _.reduce(
    fundingCategories,
    (acc, category, index) => {
      acc[category.name] = index.toString();
      return acc;
    },
    {}
  );

  const nameToFundingCategoryTargetMap = _.mapValues(nameToIndexMap, (index, name) => {
    return {
      name: name,
      ...fundingCategoryTargets[index],
    };
  });

  return nameToFundingCategoryTargetMap;
};

export const filterEntityByLimitType = (
  entities = [],
  limitType,
  fundingCategories,
  fundingCategoryTargets
) => {
  const nameToTargetMap = mapFundingCategoryTargetByName(
    fundingCategories,
    fundingCategoryTargets
  );
  return _.filter(entities, (entity) => {
    const categoryName = _.get(entity, 'payload.fundingCategory');
    return categoryName && nameToTargetMap[categoryName].calculateAgainst === limitType;
  });
};

export const filterEntityByFundingCategory = (entities = [], fundingCategory) => {
  return _.filter(
    entities,
    (entity) => _.get(entity, 'payload.fundingCategory') === fundingCategory
  );
};

export const calculateObligations = (
  validEntities,
  subAmendmentRecommendations,
  subAwardRecommendations,
  includingProjected = false
) => {
  const validSubGrantIds = validEntities.map((entity) => entity.subGrantId);

  const validSubAmendmentRecommendations = subAmendmentRecommendations.filter(
    (rec) =>
      validSubGrantIds.includes(rec.subGrantId) &&
      _.get(rec, 'payload.review.changeTypes.scopeOfWork')
  );

  const validSubAwardRecommendations = subAwardRecommendations.filter((rec) =>
    validSubGrantIds.includes(rec.subGrantId)
  );

  const matchedRecommendations = matchRecommendations(
    validSubAmendmentRecommendations,
    validSubAwardRecommendations,
    includingProjected
  );
  const amendmentObligations = sumFederalShare(
    matchedRecommendations.matchedAmendmentRecommendations
  );
  const subAwardObligations = sumFederalShare(
    matchedRecommendations.matchedAwardRecommendations
  );

  return amendmentObligations + subAwardObligations;
};

export const calculateManagementCostObligations = (
  subAmendmentRecommendations,
  subAwardRecommendations,
  includingProjected = false
) => {
  const validSubAmendmentRecommendations = subAmendmentRecommendations.filter((rec) =>
    _.get(rec, 'payload.review.changeTypes.scopeOfWork')
  );

  const matchedRecommendations = matchRecommendations(
    validSubAmendmentRecommendations,
    subAwardRecommendations,
    includingProjected
  );
  const amendmentObligations = sumManagementCost(
    matchedRecommendations.matchedAmendmentRecommendations
  );
  const subAwardObligations = sumManagementCost(
    matchedRecommendations.matchedAwardRecommendations
  );

  return amendmentObligations + subAwardObligations;
};

const matchRecommendations = (
  amendmentRecommendations,
  awardRecommendations,
  includingProjected = false
) => {
  const matchedAmendmentSubGrantIds = [];
  const matchedAmendmentRecommendations = [];
  amendmentRecommendations
    .sort((a, b) => new Date(b.modifyDate) - new Date(a.modifyDate))
    .forEach((rec) => {
      if (
        !matchedAmendmentSubGrantIds.includes(rec.subGrantId) &&
        (rec.payload.reviewPhase >= 7 ||
          rec.status === 'approved' ||
          (includingProjected && rec.status === 'submittedToFEMA'))
      ) {
        matchedAmendmentRecommendations.push(rec);
        matchedAmendmentSubGrantIds.push(rec.subGrantId);
      }
    });

  const matchedAwardRecommendations = [];
  awardRecommendations
    .sort((a, b) => new Date(b.modifyDate) - new Date(a.modifyDate))
    .forEach((rec) => {
      if (
        !matchedAmendmentSubGrantIds.includes(rec.subGrantId) &&
        (rec.payload.reviewPhase >= 7 ||
          rec.status === 'approved' ||
          (includingProjected && rec.status === 'submittedToFEMA'))
      ) {
        matchedAwardRecommendations.push(rec);
        matchedAmendmentSubGrantIds.push(rec.subGrantId);
      }
    });

  return {
    matchedAmendmentRecommendations: matchedAmendmentRecommendations,
    matchedAwardRecommendations: matchedAwardRecommendations,
  };
};

export const sumFederalShare = (recommendations) => {
  const totalAmount = recommendations.reduce((acc, cv) => {
    const fedShare =
      cv.payload.strategicFundsMgmt && cv.payload.strategicFundsMgmt.amount
        ? _.toNumber(cv.payload.strategicFundsMgmt.amount)
        : cv.payload.budget.share.fedShare.reduce((acc, cv) => acc + _.toNumber(cv), 0);

    return acc + fedShare;
  }, 0);

  return totalAmount;
};

export const sumManagementCost = (recommendations) => {
  const totalAmount = recommendations.reduce((acc, cv) => {
    const managementCost = cv.payload.budget.share.fedShare[1]
      ? _.toNumber(cv.payload.budget.share.fedShare[1])
      : 0;

    return acc + managementCost;
  }, 0);

  return totalAmount;
};

export const getTotalByFundingCategory = (
  fundingCategoryData,
  calculateAgainst,
  dataPath
) => {
  const filteredFC = _.map(
    _.filter(fundingCategoryData, (fc) => {
      return fc.calculateAgainst == calculateAgainst;
    }),
    (obj) => {
      return _.toNumber(_.get(obj, dataPath, 0));
    }
  );

  return _.sum(filteredFC);
};

export const getFundingCategoryTargetAmount = (
  lockInAmounts = {},
  targetPercent = 0,
  calculateAgainst
) => {
  const obligationLimit = getFirstNonNullKeyInObject(lockInAmounts, LOCKIN_TIMEFRAME)[
    calculateAgainst
  ]
    ? getFirstNonNullKeyInObject(lockInAmounts, LOCKIN_TIMEFRAME)[calculateAgainst]
    : 0;

  return obligationLimit * (parseFloat(targetPercent) / 100);
};

/** SHORTHAND FUNCTIONS FOR USE IN CONFIG DATA TEMPLATES **/
const templateUtility = {
  formatStringOrMilliToDate: (value) => convertDateForDisplay(value, true),
  toBoldHTML: (value) => `<strong>${value}</strong>`,
  toYesNo: (value) => (value ? 'Yes' : 'No'),
  percentOrDash: (value) => `${value || '-'}%`,
  toPrettyFormat: (value) => `${_.capitalize(value).replace('_', ' ')}`,
};

export const getValueByKey = (keyToValueMap, key) => {
  return _.get(keyToValueMap, key, '');
};

export const getParticipantDropoutReason = (key) => {
  const participantDropoutReason = {
    participantNotInterested: 'Participant not interested',
    participantIsUnresponsive: 'Participant is unresponsive',
    soldHomeToInduvidualExternalToProgram: 'Sold home to individual external to program',
    propertyIncludedInOtherHMAProject: 'Property included in other HMA project',
    processTooLong: 'Process too long',
    insufficientPurchaseOffer: 'Insufficient purchase offer',
    other: 'Other',
  };

  return _.get(participantDropoutReason, key, key);
};

/** Function name context that config "template" fields will have access to **/
const TEMPLATE_CONTEXT = {
  add: safeAdd,
  addReduce: safeAddReduce,
  addNoFixed: safeAddNoFixed,
  subtractNoFixed: safeSubstractNoFixed,
  subtract: safeSubstract,
  divide: safeDivide,
  multiply: safeMult,
  addArray: (arr) => (_.isArray(arr) ? safeAdd(...arr) : undefined),
  getTimestampNowISO,
  getTimestampOfISO,
  formatDate: templateUtility.formatStringOrMilliToDate,
  addBusinessDays: addBusinessDays,
  convertUTCDateToLocalDateDisplay: convertUTCDateToLocalDateDisplay,
  setTime: setTime,
  formatDollar: formatDollarOrEmptyString,
  getValueByKey: getValueByKey,
  getParentPath: (rootPath) => {
    return rootPath.slice(0, rootPath.lastIndexOf('.children'));
  },
  currentYear: (addOrSubtract) => {
    return CurrentYear(addOrSubtract);
  },
  arrAttrSum: (data, attributes) => {
    return arrAttrSum({array: data, attributes: attributes});
  },
  sumOfJsonPathArray: (data, jsonPathPattern, arrayIndex) => {
    return SumOfJsonPathArray(data, jsonPathPattern, arrayIndex);
  },
  isoToDisplayDate: (value) => {
    return ISOToDisplayDate(value, {showDate: true, showHours: false});
  },
  isoToDisplayDateAndTimeWithZone: (value) => {
    return ISOToDisplayDate(value, {showDate: true, showHours: true, showTimeZone: true});
  },
  isoToDisplayDateFormat: (value) => {
    return moment(value).utc().format('MM/DD/YYYY');
  },
  isoToDisplayTime: (value) => {
    return ISOToDisplayDate(value, {showDate: false, showHours: true});
  },
  isoToDisplayDateAndTime: (value) => {
    return ISOToDisplayDate(value, {showDate: true, showHours: true});
  },
  isoToDisplayExpandedDate: (value) => {
    return ISOToDisplayDate(value, {
      showDate: true,
      showHours: false,
      describeMonth: true,
    });
  },
  addMonthsToDate: addMonthsToDate,
  getDate: getDate,
  addDaysToDate: addDaysToDate,
  convertDateForDisplay: (value) => {
    return convertDateForDisplay(value, true);
  },
  allLowerCase: (str) => _.toLower(str),
  formatPercentage: showPercentageAmountWithPercentage,
  bold: templateUtility.toBoldHTML,
  toYesNo: templateUtility.toYesNo,
  gatherPhoneList: gatherPhoneList,
  percentOrDash: templateUtility.percentOrDash,
  toPrettyFormat: templateUtility.toPrettyFormat,
  statusFormatter: (status) =>
    _.get(
      PREAWARD_STATUSES,
      status,
      _.get(
        ASSOCIATED_ENTITY_STATUSES,
        status,
        _.get(PREAWARD_STATUSES, STATUS_SUBMITTED_TO_FEMA)
      )
    ),
  calculateBOCAggregates: calculateBOCAggregates,
  calculatePaymentDispursements: calculatePaymentDispursements,
  calculatePaymentDispursementsForSubGrants: calculatePaymentDispursementsForSubGrants,
  calculatePaymentFederalBalance: calculatePaymentFederalBalance,
  calculateSF425Totals: calculateSF425Totals,
  calculateCloseoutCashDisbursements: calculateCloseoutCashDisbursements,
  calculateRecipientShareOfExpenditures: calculateRecipientShareOfExpenditures,
  phoneTypeProfileToContacts,
  getItemCost: calculateItemCostTotal,
  countQuantityOfItem,
  calculateAllItemsCategorizedCostTotal: calculateAllItemsCategorizedCostTotal,
  _,
  ASSOCIATED_ENTITY_STATUSES,
  getBudgetGrandTotal: (fundingStreams, mode) =>
    calculateTotalFundingStreams({
      fundingStreams,
      mode,
    }),
  isProgramExternal: isProgramExternal,
  toStartCase: toStartCase,
  firstCharToUpperCase: firstCharToUpperCase,
  getPanelStatusAlias: (status) => _.get(PANEL_STATUS_CHANGE_DISPLAY, status),
  newlyAddedDisasterLocationNames: (options, prevDate) =>
    newlyAddedDisasterLocationNames(options, prevDate),
  formatUEIname: (data) => {
    const eft = _.trim(_.get(data, 'eft'));
    return _.get(data, 'uei') + (!_.isEmpty(eft) ? '-' + eft : '');
  },
  isInternalReadOnly: isInternalReadOnly,
  countCommentsAndAttachments: countCommentsAndAttachments,
  getFirstNonNullKeyInObject: getFirstNonNullKeyInObject,
  getFirstNonNullKeyNameInObject: getFirstNonNullKeyNameInObject,
  getSRMCTarget,
  getSRMCTargetAllRecipients,
  getSRMCObligation,
  getSRMCProjected,
  getSRMCRemainingAmountsAllRecipients,
  getTotalObligations,
  getTotalProjected,
  getTotalProjectedByLimitType,
  getTotalByFundingCategory,
  getFundingCategoryTargetAmount,
  getSumByFundingCategoryTargetAmount,
  getSumTotalObligationsOrProjectedByFoCategory,
  calculateTotalPercentByFCAndObligationLimit,
  getSumFirstNonNullKeyInObject,
  getParticipantDropoutReason,
};

export const contains = (collection, value) => {
  return _.indexOf(collection, value) > -1;
};
const shouldDisplayByRequestDetailsTotal = (data, value) => {
  const {matchBy, mode, itemCode} = value;
  let calculatedTotal = 0;
  _.forEach(data, (child) => {
    const children = _.get(child, 'children', {});
    _.filter(children, (item) => {
      if (item.itemCode === itemCode) {
        calculatedTotal = calculateChildrenTotalByMode(item.children, mode);
      }
    });
  });
  const isValid = _.toNumber(calculatedTotal) > _.toNumber(matchBy);
  return isValid;
};

export const calculateTotalFundingStreams = ({fundingStreams, mode}) => {
  const total = safeAddReduce(
    _.map(fundingStreams, (stream) => {
      return calculateChildrenTotalByMode(stream.children, mode);
    }),
    0
  );
  return total;
};

export const fetchPhaseArray = (data) => {
  let phaseArray = [];

  _.forEach(data, (child) => {
    const children = _.get(child, 'children', {});
    _.forEach(children, (item) => {
      const itemCodeCostTypeID = _.get(item, 'itemCode');
      const costItems = _.get(item, 'children');
      _.forEach(costItems, (item) => {
        phaseArray.push(item.cost[0][0].phasedProject);
      });
    });
  });

  return phaseArray;
};

const isPreAwardPhaseProject = (data, notApplicable) => {
  let flag = false;

  _.forEach(data, (child) => {
    const children = _.get(child, 'children', {});
    _.forEach(children, (item) => {
      const itemCodeCostTypeID = _.get(item, 'itemCode');
      const costItems = _.get(item, 'children');
      _.forEach(costItems, (item) => {
        if (
          item.cost[0][0].phasedProject === notApplicable &&
          item.cost[0][0].preAward !== true
        ) {
          flag = true;
        } else if (
          (item.cost[0][0].phasedProject === undefined ||
            item.cost[0][0].phasedProject !== notApplicable) &&
          item.cost[0][0].preAward === true
        ) {
          flag = true;
        }
      });
    });
  });

  return flag;
};

export const runCostEstimatePhasedProjectRule = (data, value) => {
  let isValid = false;
  if (data) {
    const {phase1, phase2, notApplicable} = value;
    const {scopeOfWork, fundingStreams} = data;

    if (scopeOfWork) {
      const {phasedProject} = scopeOfWork;
      const isPhasedProject = phasedProject;

      let phaseArray = fetchPhaseArray(fundingStreams);

      if (isPhasedProject === 'Yes' && phaseArray.length > 0) {
        if (!phaseArray.includes(phase1) || !phaseArray.includes(phase2)) {
          isValid = true;
        }
      }
    }
  }
  return isValid;
};

export const getPanelStatusAlias = (status) => {
  return _.get(PANEL_STATUS_CHANGE_DISPLAY, status);
};

export const runCostEstimatePreAwardPhasedProjectRule = (data, value) => {
  if (data) {
    const {notApplicable} = value;
    const {fundingStreams} = data;
    return isPreAwardPhaseProject(fundingStreams, notApplicable);
  } else {
    return false;
  }
};

export const evaluateOperator = (operator, firstVal, secondVal, typeVal, extraProps) => {
  let result = false;
  switch (operator) {
    case 'equal':
      result = _.isEqual(firstVal, secondVal);
      break;
    case 'notEqual':
      result = !_.isEqual(firstVal, secondVal);
      break;
    case 'lessThan':
      result = _.toNumber(firstVal) < _.toNumber(secondVal);
      break;
    case 'lessThanOrEqualTo':
      result = _.toNumber(firstVal) <= _.toNumber(secondVal);
      break;
    case 'arrayLessThanOrEqualTo':
      result = _.sum(_.toNumber(firstVal)) <= _.toNumber(secondVal);
      break;
    case 'greaterThan':
      result = _.toNumber(firstVal) > _.toNumber(secondVal);
      break;
    case 'greaterThanOrEqualTo':
      result = _.toNumber(firstVal) >= _.toNumber(secondVal);
      break;
    case 'arrayGreaterThan':
      result = _.toNumber(firstVal.reduce((a, b) => a + b, 0)) > _.toNumber(secondVal);
      break;
    case 'lengthGreaterThan':
      result = firstVal ? _.size(firstVal) > secondVal : false;
      break;
    case 'lengthLessThan':
      result = firstVal ? _.size(firstVal) < secondVal : false;
      break;
    case 'isFemaUser':
      result = isFemaUser(firstVal) === secondVal;
      break;
    case 'isRecipientUser':
      result = isRecipientUser(firstVal) === secondVal;
      break;
    case 'isProgramExternal':
      result = isProgramExternal(firstVal) === secondVal;
      break;
    case 'isFemaOrProgramExternal':
      result = isFemaOrProgramExternal(firstVal) === secondVal;
      break;
    case 'isProgramSPGAOrSMA':
      result = canViewAdminConsoleTab2(firstVal) === secondVal;
      break;
    case 'hasBankingPermissions':
      result = hasBankingPermissions(firstVal) === secondVal;
      break;
    case 'equalsAnyValue':
      result = _.includes(secondVal, firstVal);
      break;
    case 'notequalsAnyValue':
      result = !_.includes(secondVal, firstVal);
      break;

    // This is similar with 'equalsAnyValue', but it expects the first operand as a list
    case 'isValueInList':
      result = _.includes(firstVal, secondVal);
      break;
    case 'isNotValueInList':
      result = !_.includes(firstVal, secondVal);
      break;
    case 'isValueInObjectList':
      if (
        firstVal &&
        _.find(firstVal, (option) => option[secondVal.fieldName] == secondVal.value)
      ) {
        result = true;
      }
      break;
    case 'isNotValueInObjectList':
      if (
        !firstVal ||
        !_.find(firstVal, (option) => option[secondVal.fieldName] == secondVal.value)
      ) {
        result = true;
      }
      break;
    case 'costBocV1':
      result = costBocV1(firstVal, typeVal) === secondVal;
      break;
    case 'costBocV2':
      result = costBocV2(firstVal, typeVal) === secondVal;
      break;
    case 'grantType':
      result = grantType(firstVal, typeVal) === secondVal;
      break;
    case 'totalGreaterThanZero':
      result = totalGreaterThanZero(firstVal) === secondVal;
      break;
    case 'hasGrantWriterFee':
      result = hasGrantWriterFee(firstVal) === secondVal;
      break;
    case 'isMissingHiringPosition':
      result = !isMissingHiringPosition(firstVal, typeVal) === secondVal;
      break;
    case 'arrAttrSumGreaterThan':
      result =
        arrAttrSum({
          array: firstVal,
          attributes: typeVal,
        }) > secondVal;
      break;
    case 'arrAttrSumLessThanOrEqualTo':
      result =
        arrAttrSum({
          array: firstVal,
          attributes: typeVal,
        }) <= secondVal;
      break;
    case 'checkIfOneValue':
      _.forEach(typeVal, (fields, index) => {
        var question = _.get(firstVal, fields);
        if (question !== undefined) {
          _.forEach(secondVal, (value, index) => {
            if (question.response === value) {
              result = true;
            }
          });
        }
      });
      break;
    case 'isNum':
      result = checkIsNum(firstVal);
      break;
    case 'isDateValid':
      let formattedDate = null,
        dateFormat = typeVal || 'MM/DD/YYYY';
      if (dateFormat == 'MM/DD/YYYY') formattedDate = formatDateMMDDYYYY(firstVal);
      result = validDate(formattedDate, dateFormat);
      break;
    case 'isEmpty':
      result = _.isEmpty(firstVal) === secondVal;
      break;
    case 'hasItemOfCostType':
      result = hasItemOfCostType(firstVal, typeVal) === secondVal;
      break;
    case 'hasRoles':
      result =
        PermissionChecks.compareRolesAndPermissions(secondVal, firstVal) === typeVal;
      break;
    case 'hasScopedRoles':
      result = hasScopedRoles(firstVal, secondVal) === typeVal;
      break;
    case 'hasRolesForRequestForInfo':
      result =
        rfiSectionCheck(
          firstVal,
          _.get(extraProps, 'entityId'),
          getSubOrganizationId(extraProps)
        ) === typeVal;
      break;
    case 'hasRolesForTheOrg':
      result =
        PermissionChecks.compareRolesAndPermissionsForEntity(
          secondVal,
          firstVal,
          _.get(extraProps, 'entityId')
        ) === typeVal;
      break;
    case 'hasRolesForOrgProgram':
      result =
        PermissionChecks.compareRolesAndProgramsForEntity(
          secondVal,
          firstVal,
          _.get(extraProps, 'entityId'),
          _.get(extraProps, 'context.grant.programId')
        ) === typeVal;
      break;
    case 'isSAR':
      result =
        PermissionChecks.compareRolesAndPermissions(
          [ROLE_MAP.SUBAUTHREP.code],
          firstVal
        ) === typeVal;
      break;

    case 'isSARorSM':
      result =
        PermissionChecks.compareRolesAndPermissions(
          [ROLE_MAP.SUBAUTHREP.code, ROLE_MAP.SUBMEMBER.code],
          firstVal
        ) === typeVal;
      break;
    case 'isAOorSAOorGMS':
      result =
        PermissionChecks.compareRolesAndPermissions(
          [ROLE_MAP.PGMAO.code, ROLE_MAP.SAO.code, ROLE_MAP.PGMGMS.code],
          firstVal
        ) === typeVal;
      break;
    case 'isAORorPMorOMorFMorFemaUser':
      result =
        isFemaUser(firstVal) ||
        PermissionChecks.compareRolesAndPermissions(
          [
            ROLE_MAP.ORGFINMEMBER.code,
            ROLE_MAP.ORGMEMBER.code,
            ROLE_MAP.ORGPGMMEMBER.code,
            ROLE_MAP.ORGAOR.code,
          ],
          firstVal
        ) === typeVal;
      break;
    case 'shouldDisplayByRequestDetailsTotal':
      result = shouldDisplayByRequestDetailsTotal(firstVal, secondVal);
      break;
    case 'runCostEstimatePhasedProjectRule':
      result = runCostEstimatePhasedProjectRule(firstVal, secondVal);
      break;
    case 'runCostEstimatePreAwardPhasedProjectRule':
      result = runCostEstimatePreAwardPhasedProjectRule(firstVal, secondVal);
      break;
    case 'countHiringOfFirefighterPaymentsGreaterThan':
      result = countHiringOfFirefighterPaymentsGreaterThan(firstVal) > secondVal;
      break;
    case 'dateIsSameOrAfterWithRestriction':
      const secondDate = _.get(extraProps, secondVal);
      if (firstVal && secondDate) {
        result = moment(firstVal).isSameOrAfter(secondDate);
        const noMoreThanDaysInFuture = _.get(extraProps, 'noMoreThanDaysInFuture');
        if (result && noMoreThanDaysInFuture) {
          result = moment(firstVal).diff(moment(), 'days') < noMoreThanDaysInFuture;
        }
      } else {
        result = false;
      }
      break;
    case 'duplicatePhoneNumbers':
      result = duplicatePhoneNumbers(firstVal) === secondVal;
      break;
    case 'lessThanTwoUniquePhoneNumbers':
      result = lessThanTwoUniquePhoneNumbers(firstVal) === secondVal;
      break;
    case 'duplicateEmails':
      result = duplicateEmails(firstVal, secondVal) === true;
      break;
    case 'isNewDisasterLocationAdded':
      result = isNewDisasterLocationAdded(firstVal, secondVal);
      break;
    case 'isFOIDinToggleList':
      const entityType = _.get(extraProps, 'context.grant.fundingOpportunityId');
      result = _.includes(firstVal, `fundingOpportunity-${entityType}-${secondVal}`);
      break;
    case 'doesNotExist':
      result = _.isUndefined(firstVal) || _.isNull(firstVal) || firstVal === '';
      break;
    case 'isFieldEqualInObjectList':
      if (firstVal && secondVal) {
        const value = _.get(extraProps, secondVal.propValue, secondVal.value);
        const objectToCheck = _.find(
          firstVal,
          (option) => option[secondVal.fieldName] == value
        );
        if (objectToCheck) {
          const valueToCheck = _.get(objectToCheck, secondVal.compareFieldName);
          result = _.isEqual(valueToCheck, secondVal.compareValue);
        }
      }
      break;
    case 'isGreaterThanPercentageOfValuePath':
      result =
        _.toNumber(firstVal) >
        _.toNumber(_.get(extraProps, secondVal.valuePath)) * (secondVal.percentage / 100);
      break;
    case 'checkIfBsirExistForReportingPeriodWithStatus':
      result = checkIfBsirExistForReportingPeriodWithGivenStatus(
        firstVal,
        secondVal,
        typeVal
      );
      break;
    case 'isStrictlyRolesForOrg':
      result =
        PermissionChecks.isStrictlyRolesForOrg(
          firstVal,
          secondVal,
          _.get(extraProps, 'orgId')
        ) === typeVal;
      break;
    case 'hasEligibleUrbanArea':
      result = hasEligibleUrbanArea(firstVal) === secondVal;
      break;
    case 'areCostItemsTheSame':
      result = !areCostItemsChangedBetweenFundingStreams(firstVal, secondVal);
      break;
    case 'isAllSubGrantsForGrantClosed':
      result = !_.every(_.get(firstVal, 'payload'), (subGrant) =>
        _.includes(closeoutStatuses, subGrant.status)
      );
      break;
    case 'isPastDate':
      const dateToCheck = moment(firstVal).utc().endOf('day');
      const now = moment().utc();
      result = now.isAfter(dateToCheck);
      break;
    default:
      result = _.get(PermissionChecks, operator, false)
        ? PermissionChecks[operator](firstVal) === secondVal
        : false;
  }
  return result;
};

export const checkIfBsirExistForReportingPeriodWithGivenStatus = (
  firstVal,
  secondVal,
  status
) => {
  return _.some(firstVal, (bsir) => {
    return (
      _.isEqual(_.get(bsir, 'payload.reportingPeriodEndDate'), secondVal) &&
      _.isEqual(_.get(bsir, 'status'), status)
    );
  });
};

export const hasEligibleUrbanArea = (fundingStreams) => {
  let result = false;
  _.forEach(fundingStreams, (stream) => {
    if (!result) {
      result = searchChildrenForUrbanArea(stream.children);
    }
  });

  return result;
};

const searchChildrenForUrbanArea = (children) => {
  let hasUrbanArea = false;

  _.forEach(children, (child) => {
    if (!hasUrbanArea) {
      const urbanArea = _.get(child, 'additionalInformation.eligibleUrbanArea');
      hasUrbanArea =
        (urbanArea && urbanArea !== 'None') || searchChildrenForUrbanArea(child.children);
    }
  });

  return hasUrbanArea;
};

function extractCostAndItemCode(obj) {
  let result = [];
  _.forEach(obj, (value, key) => {
    if (_.has(value, 'cost') && _.has(value, 'itemCode')) {
      result.push({
        itemCode: key,
        cost: {
          itemCode: key,
          price: value.cost[0][0].price,
          total: value.cost[0][0].quantity,
          actualQuantity: value.cost[0][0].actualQuantity
            ? value.cost[0][0].actualQuantity
            : value.cost[0][0].quantity,
          actualPrice: value.cost[0][0].actualPrice
            ? value.cost[0][0].actualPrice
            : value.cost[0][0].price,
        },
      });
    }
    if (_.has(value, 'children')) {
      result = _.concat(result, extractCostAndItemCode(value.children));
    }
  });

  return result;
}

//compares funding streams and checks if there are changes in the cost items
export function areCostItemsChangedBetweenFundingStreams(original, updated) {
  let originalCosts = extractCostAndItemCode(original);
  let updatedCosts = extractCostAndItemCode(updated);
  let result = compareCosts(originalCosts, updatedCosts);

  return result.updated;
}

function compareCosts(originalCosts, updatedCosts) {
  let modified = [];
  let newCosts = [];

  _.forEach(updatedCosts, (updatedCostValue, updatedCostKey) => {
    let originalCostValue = _.find(originalCosts, (originalCostValue) => {
      return _.isEqual(originalCostValue.itemCode, updatedCostValue.itemCode);
    });

    if (originalCostValue && !_.isEqual(originalCostValue.cost, updatedCostValue.cost)) {
      modified.push(updatedCostValue);
    } else if (!originalCostValue) {
      newCosts.push(updatedCostValue);
    }
  });

  return {modified, new: newCosts, updated: modified.length > 0 || newCosts.length > 0};
}

export const hasGrantWriterFee = (fundingStreams) => {
  const fundingStream = _.find(
    fundingStreams,
    (stream) => stream.fundingStreamType === 'preAwardCosts'
  );
  if (fundingStream) {
    if (searchChildren(fundingStream.children)) {
      return true;
    }
  }
  return false;
};

const searchChildren = (children) => {
  let hasGrantWritingFee = false;

  _.forEach(children, (child) => {
    if (!hasGrantWritingFee) {
      hasGrantWritingFee =
        _.isEqual(child.itemCode, 48) || searchChildren(child.children);
    }
  });

  return hasGrantWritingFee;
};

export const isMissingHiringPosition = (fundingStreams, itemCodes) => {
  const fundingStream = _.find(
    fundingStreams,
    (stream) => stream.fundingStreamType === 'hiringOfFirefighters'
  );
  if (fundingStream) {
    if (searchChildrens(fundingStream.children, itemCodes)) {
      return true;
    }
  }
  return false;
};

const searchChildrens = (fundingStreams, itemCodes) => {
  let hasChildren = false;

  _.forEach(fundingStreams, (stream) => {
    _.forEach(stream.children, (child) => {
      if (!hasChildren) {
        hasChildren =
          _.includes(itemCodes, child.itemCode) || searchChildrens(child.children);
      }
    });
  });

  return hasChildren;
};

export const totalGreaterThanZero = (costValues) => {
  let total = 0;
  _.forEach(costValues, (costValue) => (total = safeAdd(total, costValue)));
  if (total > 0) {
    return true;
  }
  return false;
};

export const costBocV1 = (budgetSummary, typeVal) => {
  if (_.find(budgetSummary, (item) => _.trim(item.boc) === typeVal && item.total > 0)) {
    return true;
  }
  return false;
};

export const costBocV2 = (budgetSummary, typeVal) => {
  if (
    _.find(
      budgetSummary,
      (item, key) => key === _.camelCase(_.trim(typeVal)) && _.sum(item) > 0
    )
  ) {
    return true;
  }
  return false;
};

export const arrSumAsNumber = (array) => {
  var sum = 0;
  for (var i = 0; i < array.length; i++) {
    sum = sum + Number(array[i]);
  }
  return sum;
};

export const arrAttrSum = (data) => {
  var sum = 0;
  if (data) {
    if (data.array) {
      var arrayData = data.array;
      if (data.attributes) {
        var attributes = data.attributes;
        for (var i = 0; i < attributes.length; i++) {
          var attribute = attributes[i];
          var attributeValues = jsonPath.query(arrayData, attribute);
          sum = sum + arrSumAsNumber(attributeValues);
        }
      }
    }
  }

  return sum;
};

export const grantType = (fundingStreams, typeVal) => {
  if (_.find(fundingStreams, (item) => _.trim(item.fundingStreamType) === typeVal)) {
    return true;
  }
  return false;
};

export const buildBookmarkLink = (props) => {
  const {parseAll} = props;
  let content = props.content;
  let contentToRender = [];

  _.forEach(props.links, (link, index) => {
    let onClick = (e) => {
      if (props.setCurrentFieldList) {
        props.setCurrentFieldList(link.location);
      }
    };

    let contentParts = _.split(content, `<a>${link.text}</a>`);
    content = _.replace(content, contentParts[0], '');
    content = _.replace(content, `<a>${link.text}</a>`, '');

    let linkCode = (
      <a href={link.href} onClick={onClick} title={link.text}>
        {link.text}
      </a>
    );

    const firstPart = _.get(contentParts, 0, '');
    contentToRender.push(
      <React.Fragment key={index}>
        {parseAll ? ReactHtmlParser(firstPart) : firstPart}
        {linkCode}
      </React.Fragment>
    );
  });
  contentToRender.push(
    <React.Fragment key="content">
      {parseAll ? ReactHtmlParser(content) : content}
    </React.Fragment>
  );

  return contentToRender;
};
export const calculateLastNonZeroBudgetPeriod = (fedShareByPeriod) =>
  _.findLastIndex(fedShareByPeriod, (fedShare) => fedShare > 0) + 1;

export const calculatePOPEndDate = (programId, fundingStreams, numPeriods, startDate) => {
  let endDate = null;
  if (programId == 10) {
    endDate = moment(startDate).add(12, 'month');
  } else if (programId == 11) {
    const fundingStreamTypes = _.map(fundingStreams, (stream) =>
      _.get(stream, 'fundingStreamType', '')
    );
    if (_.includes(fundingStreamTypes, RECRUITMENT_AND_RETENTION)) {
      endDate = moment(startDate).add(12 * numPeriods, 'month');
    } else if (_.includes(fundingStreamTypes, HIRING_OF_FIREFIGHTERS)) {
      endDate = moment(startDate).add(36, 'month');
    }
  } else if (programId === 12) {
    endDate = moment(startDate).add(12 * numPeriods, 'month');
  }

  return endDate != null ? endDate.subtract(1, 'day') : endDate;
};
export const calculateProgramArea = (programId, grantId, fundingStreamsJson) => {
  const fundingStreams = JSON.parse(fundingStreamsJson || '[]');
  return _.join(
    _.map(
      _.filter(fundingStreams, (stream) => stream !== 'preAwardCosts'),
      (streamKey) => FUNDING_STREAM_NAME[streamKey]
    ),
    ','
  ); // only one item in blacklist for now
};
//moved it from TaskSchedule to utils
export const modalVal = (props) => {
  const {validationErrors, validationDirtyMap} = props;

  // Find errors associated with a specific field name.
  const findError = (field) => {
    const errs = _.get(_.get(validationErrors, 0), field);
    if (errs instanceof Array) {
      return _.find(errs, (err) => !err.isValid);
    }
    return errs;
  };

  // Determine whether a specific field is valid (has any errors).
  const displayError = (field) => _.get(findError(field), 'isValid') === false;

  // Grab the error message associated with a specific field.
  const errorMessage = (field) => _.get(findError(field), 'message');

  // Determine whether a specific field has been touched.
  const isDirty = (field) => {
    // If a dirty map entry for the field exists, check it.
    if (_.get(validationDirtyMap, ['dirty', field])) {
      return _.get(validationDirtyMap, ['dirty', field], false);
    } else {
      // If a dirty map entry for the field does not exist, use the overall dirty map setting
      // for this modal.  We need to do this as the DynamicValidateContinueButton will set the dirty
      // map for the top level validation id only.  It does not set it for the nested fields.
      // So if upon initial page load, we click the Continue button, the field level dirty map has
      // not been set up at all.
      return _.get(validationDirtyMap, 'dirty');
    }
  };

  // Grab the display toggle and error messages for the tasks field.
  const tasksErrorMessages = errorMessage('tasks');
  // Display an error message if the field has been touched and has an error.
  const tasksDisplayError = isDirty('tasks') && displayError('tasks');

  const retObj = {
    tasksErrorMessages: tasksErrorMessages,
    tasksDisplayError: tasksDisplayError,
  };
  return retObj;
};

// Checks if fieldname is dirty (includes check for dirty page)
export const isDirty = (validationDirtyMap, fieldName) => {
  let dirtyToCheck = 'dirty';
  if (fieldName !== undefined) {
    dirtyToCheck = fieldName;
  }

  return (
    _.get(validationDirtyMap, 'dirtyPage') ||
    _.get(validationDirtyMap, dirtyToCheck, false)
  );
};

export const getErrorForField = (validationErrors, fieldName) => {
  return _.get(
    _.find(validationErrors, (err) => _.get(err, fieldName) !== undefined),
    fieldName
  );
};

export const parseError = (error) => {
  if (_.isArray(error)) {
    return _.find(error, (err) => _.get(err, 'isValid') === false);
  } else {
    return error;
  }
};

export const getFirstErrorForField = (validationErrors, fieldName) => {
  return parseError(getErrorForField(validationErrors, fieldName));
};

export const getFirstObjectError = (errorObject) => {
  let result = {};
  _.forEach(errorObject, (err) => {
    const foundError = parseError(err);
    if (_.get(foundError, 'isValid') === false) {
      result = foundError;
      return false;
    }
  });
  return result;
};

// Supports checking for errors for complex components that would come out of validateNestedRules or validateObject
export const displayObjectErrors = (validationErrors, validationDirtyMap, fieldName) => {
  let err = _.get(validationErrors, fieldName);
  let dirtyVal = isDirty(validationDirtyMap, fieldName);

  let displayError = err !== undefined && dirtyVal;
  let errorMessages = '';

  if (_.isArray(err)) {
    const invalidErrs = _.filter(err, (e) => e.isValid !== true);
    if (_.size(invalidErrs) > 0) {
      errorMessages = _.get(invalidErrs, [0, 'message']);
    }
    err = _.get(invalidErrs, 0);
    displayError = displayError && !_.isEmpty(invalidErrs);
  } else if (err !== undefined) {
    displayError = displayError && _.get(err, 'isValid') !== true;
    errorMessages = _.get(err, 'message');
  }

  return {
    ...(_.isObject(err) ? err : {}),
    displayError,
    errorMessages,
  };
};

export const getFirstInvalidErrorMessage = (dirtyMap, errors) => {
  if (_.get(dirtyMap, 'dirty') || _.get(dirtyMap, 'dirtyPage')) {
    return _.get(
      _.find(errors, (err) => !err.isValid),
      'message'
    );
  }
  return false;
};

export const isDisplayError = (dataErrors, fieldName) => {
  if (dataErrors === undefined) {
    return false;
  }
  let value = _.get(dataErrors, fieldName);
  return value !== undefined && !_.isEmpty(value);
};

export const errorMessages = (dataErrors, fieldName) => {
  if (dataErrors === undefined) {
    return [];
  }
  let array = _.get(dataErrors, fieldName);
  if (array !== undefined) {
    return _.uniq(array).map((value, index) => {
      return <div key={index}>{ReactHtmlParser(value)} </div>;
    });
  }
  return [];
};

export const checkWithinApplicationDeadline = (foData) => {
  if (!foData) {
    return false;
  }
  return moment().isBetween(foData.aplcnStartDate, foData.aplcnEndDate);
};

export const checkWithinApplicationDeadlineWithGracePeriod = (foData) => {
  if (!foData) return false;
  // When grace period is null lodash get function is returning without evaluating second conditon.
  let aplcnEndDate = _.get(foData, 'aplcnGracePd');
  if (!aplcnEndDate || aplcnEndDate === null) {
    aplcnEndDate = _.get(foData, 'aplcnEndDate');
  }
  return moment().isBetween(foData.aplcnStartDate, aplcnEndDate);
};

export const checkProcessInstanceTerminated = (
  entity,
  token,
  processInstanceId,
  callback,
  maxCalls
) => {
  if (!maxCalls) {
    maxCalls = 100;
  }
  REST.workflow
    .checkProcessInstanceStatus(token, processInstanceId)
    .then(REST.handler.handleResponse)
    .then((status) => {
      // TODO remove OpenAPI toggle code
      if (status == 'ended' || _.get(status, 'result') == 'ended') {
        callback(entity);
      } else if (maxCalls > 0) {
        //setTimeout(()=>
        checkProcessInstanceTerminated(
          entity,
          token,
          processInstanceId,
          callback,
          --maxCalls
        );
        //1000
        //);
      } else {
        callback(null);
      }
    });
  return true;
};

export const cancelCloseoutReport = (reportEntity, token, callback) => {
  let currentDate = getTimestampNowISO();
  const grantEntity = {
    entityId: reportEntity.grantId,
    grantId: reportEntity.grantId,
    statusTimestamp: currentDate,
    status: 'awardAccepted',
  };

  REST.dynamicData
    .patchEntity(token, grantEntity)
    .then(REST.handler.handleResponse)
    .then(() => {
      REST.dynamicData
        .deleteEntity(token, reportEntity.entityId)
        .then(REST.handler.handleResponse)
        .then(() => {
          callback(false, '');
        })
        .catch((error) => {
          callback(
            false,
            'An error happened while trying to delete this closeout report'
          );
        });
    })
    .catch((error) => {
      callback(
        false,
        'An error happened while trying to update this grant status back to Award accepted'
      );
    });
};

export const cancelSubCloseoutReport = (reportEntity, token, callback) => {
  let currentDate = getTimestampNowISO();
  const subGrantEntity = {
    entityId: reportEntity.subGrantId,
    grantId: reportEntity.subGrantId,
    statusTimestamp: currentDate,
    status: 'subAwardAccepted',
  };

  REST.dynamicData
    .patchEntity(token, subGrantEntity)
    .then(REST.handler.handleResponse)
    .then(() => {
      REST.dynamicData
        .deleteEntity(token, reportEntity.entityId)
        .then(REST.handler.handleResponse)
        .then(() => {
          callback(false, '');
        })
        .catch((error) => {
          callback(
            false,
            'An error happened while trying to delete this subcloseout report'
          );
        });
    })
    .catch((error) => {
      callback(
        false,
        'An error happened while trying to update this subgrant status back to Award accepted'
      );
    });
};

export const checkActivityCompleted = ({
  token,
  processInstanceId,
  activityId,
  activityResponse,
  callback,
  maxTimeout,
  activityMaxCount,
  checkTaskVal,
}) => {
  if (!maxTimeout) {
    maxTimeout = 30000;
  }

  const endTime = Date.now() + maxTimeout;
  let attempt = 0;
  let successful = false;
  let foundStatus = null;
  let foundTask = null;

  const getResult = async () => {
    while (Date.now() < endTime) {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const res = await REST.workflow
        .checkActivityStatus(token, processInstanceId, activityId, activityMaxCount)
        .then(REST.handler.handleResponse);

      foundStatus = _.isObject(res) ? _.get(res, 'result') : res;
      foundTask = _.isObject(res) ? _.get(res, 'id') : res;

      // console.log("Checking activity status:", foundStatus, "Attempt #", attempt);

      if (
        res !== undefined &&
        ((foundStatus == activityResponse && (!checkTaskVal || foundTask !== '')) ||
          (activityResponse == ACTIVITY_RESPONSES.active &&
            foundStatus == ACTIVITY_RESPONSES.ended))
      ) {
        return callback(foundStatus);
      }
      attempt++;
    }

    // If no status found after all attempts, log it and continue
    console.log(`Activity with ID ${activityId} not found after ${attempt} attempts.`);

    // Continue to the next logic, even though the task was not found
    return callback(null);
  };

  return getResult();
};

export const checkAndHandleEntityStatusSync = (
  token,
  entityId,
  entityStatusWorkflow,
  callback,
  maxCalls = 100,
  delayTime = 1000,
  maxWait = 10000
) => {
  const fetchEntityData = async () => {
    try {
      const entityData = await REST.dynamicData
        .getEntityById(token, entityId)
        .then(REST.handler.handleResponse);
      if (entityData && entityData.status && entityData.status == entityStatusWorkflow) {
        return callback();
      } else {
        throw new Error('Entity status is not ' + entityStatusWorkflow);
      }
    } catch (err) {
      throw err;
    }
  };

  return retry(fetchEntityData, {
    maxAttempts: maxCalls,
    factor: 2,
    delay: delayTime,
    maxDelay: maxWait,
    jitter: true,
  })
    .then((result) => {
      return result; // Return the result of the successful callback execution
    })
    .catch((err) => {
      console.error('Max retries reached or an error occurred:', err);
      throw err; // In case all retries fail, throw the error
    });
};

export const disableAmendmentRequest = (grantFoData, amendments) => {
  const bsirReporting = _.get(grantFoData, 'configData.reporting.bsirReporting', false);
  if (!bsirReporting) {
    return true;
  } else {
    if (_.isEmpty(amendments)) {
      return true;
    } else {
      return !_.some(
        amendments,
        (amendment) =>
          amendment.status === STATUS_PENDING_SUBMISSION ||
          amendment.status === STATUS_SUBMITTED_TO_FEMA ||
          amendment.status === STATUS_RETURNED_TO_RECIPIENT
      );
    }
  }
};

export const enableSubAmendmentRequest = (
  toggles,
  grantFoData,
  grant,
  amendments,
  inprogressSubAmendments
) => {
  const allowRecipientToAmendSubSection = _.get(
    grantFoData,
    'configData.foOverview.allowRecipientToAmendSubSection',
    false
  );
  if (
    _.includes(toggles, 'enableProjectFormulationPostAward') &&
    allowRecipientToAmendSubSection &&
    grant !== undefined &&
    grant.entityType === 'subGrant'
  ) {
    if (inprogressSubAmendments) {
      return false;
    } else if (_.isEmpty(amendments)) {
      return true;
    } else {
      return !_.some(
        amendments,
        (amendment) =>
          amendment.status === STATUS_PENDING_SUBMISSION ||
          amendment.status === STATUS_SUBMITTED_TO_FEMA ||
          amendment.status === STATUS_RETURNED_TO_RECIPIENT
      );
    }
  } else {
    return true;
  }
};

const closeoutStatuses = [
  STATUS_CLOSED,
  STATUS_INELIGIBLE,
  STATUS_NOT_SELECTED,
  STATUS_SUBAWARD_RESCINDED,
];

export const getGrantActions = (
  grant,
  toggles,
  permissions,
  entitiesEnabled,
  appExtension,
  currentOrg,
  hasOrgSubOrgRelationshipForEntitySix,
  rolesToCheck,
  pageEntityType,
  parentList,
  isAmendmentPaymentSubmitedToFema,
  closeoutReportStatus,
  foData = [],
  amendments = [],
  subCloseoutReportStatus,
  subGrantsForGrant,
  isPassthroughGrant,
  inprogressSubAmendments,
  propertyData,
  subApplicationGrant
) => {
  const grantStatus = _.get(grant, 'status');
  const grantFoID = _.get(grant, 'fundingOpportunityId');
  const grantFoData = _.find(foData, {fundingOpportunityId: _.toNumber(grantFoID)});
  const enableAmendmentRequests = disableAmendmentRequest(grantFoData, amendments);
  const enableSubGrantAmendment = enableSubAmendmentRequest(
    toggles,
    grantFoData,
    grant,
    amendments,
    inprogressSubAmendments
  );
  let grantReadyForCloseout = false;

  if (subGrantsForGrant != undefined) {
    const subGrants = _.filter(subGrantsForGrant.payload, (subGrant) => {
      return _.includes(closeoutStatuses, subGrant.status) ? subGrant : null;
    });
    grantReadyForCloseout = subGrants.length == subGrantsForGrant.payload.length;
  }

  let liqDeadLine = moment(
    _.get(grant, 'payload.liquidationDeadline'),
    'YYYY-MM-DDTHH:mm:ssZ'
  );
  const liquidationDeadlineString = _.get(grant, 'payload.liquidationDeadline');
  if (
    liqDeadLine &&
    liquidationDeadlineString &&
    liquidationDeadlineString.length <= 10
  ) {
    liqDeadLine = liqDeadLine.add(1, 'days');
  }
  const popStartDate = moment(
    _.get(grant, 'payload.periodOfPerformance.startDate'),
    'YYYY-MM-DDTHH:mm:ssZ'
  );

  const popEndDate = moment(
    _.get(grant, 'payload.periodOfPerformance.endDate'),
    'YYYY-MM-DDTHH:mm:ssZ'
  );

  const now = moment();
  var actions = [];
  if (
    _.isEqual(_.get(grant, 'status'), STATUS_AWARD_ACCEPTED) &&
    canViewPostAwardEntities(permissions)
  ) {
    if (now.isAfter(popStartDate) && now.isBefore(liqDeadLine)) {
      actions.push({
        text: 'Request a payment',
        value: 'payment',
      });
    }

    if (pageEntityType !== ENTITY_PAGE_TYPE_SUBGRANT && enableAmendmentRequests) {
      actions.push({
        text: 'Request an amendment',
        value: 'amendment',
      });
    }

    if (
      _.includes(toggles, 'performanceProgressReport') &&
      !_.includes(toggles, 'pprScheduler')
    ) {
      actions.push({
        text: 'Submit performance progress report',
        value: 'performanceProgressReport',
      });
    }

    if (
      (_.includes(toggles, 'enableGrantCloseoutInitiation') &&
        _.isEqual(grantStatus, STATUS_AWARD_ACCEPTED) &&
        grantReadyForCloseout &&
        now.isAfter(popEndDate) &&
        !(
          amendments.length !== 0 &&
          _.some(amendments, (amendment) => amendment.status === 'submittedToFEMA')
        ) &&
        isPassthroughGrant) ||
      (now.isAfter(popEndDate) &&
        !isAmendmentPaymentSubmitedToFema &&
        !isPassthroughGrant)
    ) {
      actions.push({
        text: 'Initiate closeout',
        value: 'closeoutReport',
      });
    }
  }

  if (
    hasOrgSubOrgRelationshipForEntitySix &&
    _.includes(parentList, _.get(grant, 'organizationId')) &&
    canContinueSubapplicationSubmitted(
      permissions,
      currentOrg,
      rolesToCheck,
      _.get(grant, 'programId'),
      _.get(grant, 'organizationId')
    ) &&
    _.isEqual(grantStatus, STATUS_PENDING_SUBMISSION)
  ) {
    actions.push({
      text: 'Continue subapplication',
      value: 'continueSubApplication',
    });
  }
  const canViewSubAppStatuses = [
    STATUS_PENDING_SUBMISSION,
    STATUS_SUBMITTED_TO_RECIPIENT,
    STATUS_INELIGIBLE,
    STATUS_NOT_SELECTED,
    STATUS_PENDING_AOR_SUBMISSION,
  ];
  const reviewByRecipientTaskNavStatuses = [
    STATUS_APPROVED_BY_RECIPIENT,
    STATUS_DISAPPROVED_BY_RECIPIENT,
    STATUS_STOCKPILE,
    STATUS_SAVED_FOR_LATER,
  ];
  if (pageEntityType === 'fundingOpportunity') {
    actions.push({
      text: 'View subapplication',
      value: 'viewSubApplication',
    });
  }

  if (
    ((canViewSubapplication(permissions, currentOrg, rolesToCheck) ||
      canViewAndContinueSubapplication(permissions, currentOrg, rolesToCheck)) &&
      _.includes(canViewSubAppStatuses, grantStatus)) ||
    (_.includes(toggles, 'ReviewByRecipientTaskNav') &&
      _.includes(reviewByRecipientTaskNavStatuses, grantStatus)) ||
    (_.includes(toggles, 'signSubPendAorFmaBric') &&
      _.isEqual(grantStatus, STATUS_SUBMITTED_TO_FEMA)) ||
    _.isEqual(grantStatus, STATUS_SUBAWARD_ACCEPTED) ||
    _.isEqual(grantStatus, STATUS_SUBAWARD_OFFERED) ||
    _.isEqual(grantStatus, STATUS_SUBAWARD_DECLINED)
  ) {
    actions.push({
      text: 'View subapplication',
      value: 'viewSubApplication',
    });
    if (_.isEqual(grantStatus, STATUS_PENDING_SUBMISSION)) {
      actions.push({
        text: 'Continue subapplication',
        value: 'continueSubApplication',
      });
    }
  }

  // This permissions check holds all the same ones as required for subapp deletion
  if (
    _.isEqual(grantStatus, STATUS_PENDING_SUBMISSION) &&
    canViewSubGrantAmendmentsAndPayments(permissions, currentOrg, rolesToCheck)
  ) {
    actions.push({
      text: 'Delete subapplication',
      value: 'deleteSubApplication',
    });
  }

  if (
    hasOrgSubOrgRelationshipForEntitySix &&
    _.includes(parentList, _.toString(_.get(grant, 'organizationId'))) &&
    canContinueSubapplicationSubmitted(
      permissions,
      currentOrg,
      rolesToCheck,
      _.get(grant, 'programId'),
      _.get(grant, 'organizationId')
    ) &&
    _.isEqual(grantStatus, STATUS_PENDING_SAR_SIGNATURE)
  ) {
    actions.push({
      text: 'Continue subapplication',
      value: 'continueSubApplication',
    });
  } else if (
    (canViewSubapplication(permissions, currentOrg, rolesToCheck) &&
      _.isEqual(grantStatus, STATUS_PENDING_SAR_SIGNATURE)) ||
    (isSM(permissions) &&
      pageEntityType === ENTITY_PAGE_TYPE_SUBGRANT &&
      _.isEqual(grantStatus, STATUS_PENDING_SAR_SIGNATURE))
  ) {
    actions.push({
      text: 'View subapplication',
      value: 'viewSubApplication',
    });
  }

  if (
    _.includes(BEFORE_FINAL_SUBMISSION_STATUSES, _.get(grant, 'status')) &&
    canViewAndContinueApplication(permissions)
  ) {
    if (
      canContinueApplications(
        permissions,
        grant.status,
        appExtension ? appExtension.extendedApplicationEndDate : grant.aplcnEndDate,
        toggles,
        _.get(grant, 'fundingOpportunityId')
      )
    ) {
      actions.push({
        text: 'Continue application',
        value: 'continueApplication',
      });
    }
    if (canViewPostAwardEntities(permissions)) {
      actions.push({
        text: 'View application',
        value: 'viewApplication',
      });
    }
  }

  if (
    _.isEqual(grantStatus, STATUS_INELIGIBLE) &&
    canViewAndContinueApplication(permissions)
  ) {
    actions.push({
      text: 'View application',
      value: 'viewApplication',
    });
  }
  /* TODO: Revert code used to implement GMMGO-39048 once fundingOpportunity-####-closeoutReview toggles deployed
   * Once those toggles are deployed, will no longer need the closeoutReport status to determine whether or not
   * to display "Restore grant to post-award phase" action.  Can remove the parameter to this getGrantActions()
   * function as well as from canCancelCloseoutReport()
   * See See GMMGO-39113
   */
  if (
    canCancelCloseoutReport(permissions, _.get(grant, 'status'), closeoutReportStatus)
  ) {
    actions.push({
      text: 'Restore grant to post-award phase',
      value: 'cancelCloseoutReport',
    });
  } else if (
    _.includes([STATUS_SUBMITTED_TO_FEMA], grantStatus) &&
    _.get(grantFoData, 'configPath') === 'passthrough/0' &&
    checkWithinApplicationDeadlineWithGracePeriod(grantFoData) &&
    canViewAndContinueApplication(permissions)
  ) {
    actions.push({
      text: 'Continue application',
      value: 'continueApplication',
    });
    actions.push({
      text: 'View application',
      value: 'viewApplication',
    });
  } else if (
    _.includes([STATUS_SUBMITTED_TO_FEMA, STATUS_NOT_SUBMITTED], grantStatus) &&
    canViewPostAwardEntities(permissions)
  ) {
    if (
      _.isEqual(grantStatus, STATUS_SUBMITTED_TO_FEMA) &&
      canReopenApplications(
        permissions,
        grant.status,
        appExtension ? appExtension.extendedApplicationEndDate : grant.aplcnEndDate,
        toggles,
        _.get(grant, 'fundingOpportunityId'),
        null,
        _.get(grant, 'payload.programType')
      )
    ) {
      actions.push({
        text: 'Reopen application',
        value: 'reopenApplication',
      });
    }

    if (
      _.get(grantFoData, 'configPath') === 'passthrough/0' &&
      checkWithinApplicationDeadlineWithGracePeriod(grantFoData) &&
      canViewAndContinueApplication(permissions)
    ) {
      actions.push({
        text: 'Continue application',
        value: 'continueApplication',
      });
    }
    actions.push({
      text: 'View application',
      value: 'viewApplication',
    });
  }

  if (
    _.isEqual(grantStatus, STATUS_SUBMITTED_TO_RECIPIENT) &&
    isUserAllowedBulk(
      ['isUserRoleAllowed', 'isUserOrgProgramAllowed'],
      permissions,
      _.get(grant, 'organizationId'),
      AUTHORIZED_VIEW_SUB_APP_ROLES
    )
  ) {
    actions.push({
      text: 'Review subapplication',
      value: 'reviewSubApplication',
    });
  }

  if (_.isEqual(grantStatus, STATUS_RETURNED_TO_SUBRECIPIENT)) {
    actions.push(
      {
        text: 'Continue application',
        value: 'continueApplication',
      },
      {
        text: 'Continue subapplication',
        value: 'continueSubApplication',
      }
    );
  } else if (
    canViewSubapplication(permissions, currentOrg, rolesToCheck) &&
    ((_.isEqual(grantStatus, STATUS_APPROVED_BY_RECIPIENT) &&
      !_.isEqual(_.get(grant, 'inner_hits.payload.subApplicationId'), grant.entityId)) ||
      _.includes(
        [STATUS_DISAPPROVED_BY_RECIPIENT, STATUS_STOCKPILE, STATUS_SAVED_FOR_LATER],
        grantStatus
      ))
  ) {
    actions.push({
      text: 'Change subapplication status',
      value: 'changeSubApplicationStatus',
    });
  }

  if (
    _.isEqual(grantStatus, STATUS_SUBAWARD_ACCEPTED) &&
    canCreateSubgrantPaymentRequest(
      permissions,
      _.get(grant, 'organizationId'),
      _.get(grant, 'programId')
    )
  ) {
    actions.push({
      text: 'Request a payment',
      value: 'payment',
    });
  }

  if (
    _.isEqual(grantStatus, STATUS_SUBAWARD_ACCEPTED) &&
    enableSubGrantAmendment &&
    canViewPostAwardEntities(permissions)
  ) {
    actions.push({
      text: 'Request an amendment',
      value: 'subAmendmentRecommendation',
    });
  }

  if (
    _.isEqual(grantStatus, STATUS_PENDING_AOR_SUBMISSION) &&
    canSubmitSubapplicationsToFEMA(
      permissions,
      _.get(grant, 'organizationId'),
      _.get(grant, 'programId')
    )
  ) {
    actions.push({
      text: 'Submit to FEMA',
      value: 'submitToFEMA',
    });
  }

  if (
    _.includes(toggles, 'enableSubgrantCloseoutInitiation') &&
    _.isEqual(grantStatus, STATUS_SUBAWARD_ACCEPTED) &&
    canInitiateOrContinueSubCloseoutReport(permissions, _.get(grant, 'organizationId'))
  ) {
    actions.push({
      text: 'Initiate subgrant closeout',
      value: 'subCloseoutReport',
    });
  }

  if (
    _.isEqual(grantStatus, STATUS_CLOSEOUT_INITIATED) &&
    canInitiateOrContinueSubCloseoutReport(permissions, _.get(grant, 'organizationId'))
  ) {
    actions.push({
      text: 'Continue subgrant closeout report',
      value: 'continueSubCloseoutReport',
    });
  }

  if (
    _.isEqual(grantStatus, STATUS_CLOSEOUT_INITIATED) &&
    canCancelSubCloseoutReport(permissions, _.get(grant, 'organizationId')) &&
    (_.isEqual(subCloseoutReportStatus, STATUS_PENDING_SUBMISSION) ||
      _.isEqual(subCloseoutReportStatus, STATUS_SUBMITTED_TO_FEMA))
  ) {
    actions.push({
      text: 'Restore subgrant to post-award phase',
      value: 'cancelSubCloseoutReport',
    });
  }

  const hasProjectSiteInventoryLocations =
    _.get(
      subApplicationGrant,
      'payload.location.projectSiteInventory.knowlocationStructure',
      'No'
    ) === 'Yes' &&
    _.get(
      subApplicationGrant,
      'payload.location.projectSiteInventory.projectMitigatingStructures',
      'No'
    ) === 'Yes';
  if (
    _.includes(toggles, 'enablePropertyDataMitigation') &&
    grantFoData &&
    _.get(grantFoData, 'configData.foOverview.mitigatedPropertySiteFundsPaid', false) &&
    hasProjectSiteInventoryLocations &&
    _.isNil(subCloseoutReportStatus) &&
    (isAOR(permissions) || isSAR(permissions)) &&
    grant.status !== STATUS_CLOSED &&
    grant.entityType === ENTITY_TYPE_SUBGRANT &&
    (_.isEmpty(propertyData) ||
      (!_.isEmpty(propertyData) && propertyData[0].status === STATUS_SUBMITTED_TO_FEMA))
  ) {
    actions.push({
      text: 'Edit property data',
      value: 'propertyData',
    });
  }

  const actionsForFo = _.uniqBy(
    _.filter(actions, (action) => _.includes(entitiesEnabled, action.value)),
    'value'
  );

  return actionsForFo;
};

export const getAppActions = (tabEntityType, entitiesEnabled, tabName, permission) => {
  var actions = [];

  if (tabEntityType == 'grant') {
    actions.push({
      text: 'View grant',
      value: 'viewGrant',
    });
  }

  if (tabEntityType == 'application') {
    actions.push({
      text: 'View application',
      value: 'viewApplication',
    });
    if (tabName == 'appsDraft' && isRecipientUser(permission)) {
      actions.push({
        text: 'Continue application',
        value: 'continueApplication',
      });
    }
  }
  const filteredActions = _.filter(actions, (action) =>
    _.includes(entitiesEnabled, action.value)
  );

  return filteredActions;
};

export const getRfaActions = (rfa, permissions, entitiesEnabled) => {
  const rfaStatus = _.get(rfa, 'status');
  const rfaProgram = _.get(rfa, 'programId');
  const rfaOrgId = _.get(rfa, 'organizationId');
  const rfaSubOrgId = getSubOrganizationId(rfa);
  var actions = [];

  const SUBMITTED_RFA_STATUSES = [
    STATUS_SUBMITTED_TO_FEMA,
    STATUS_APPROVED,
    STATUS_DENIED,
  ];

  if (
    _.includes(SUBMITTED_RFA_STATUSES, rfaStatus) &&
    (canViewAndContinueApplication(permissions) ||
      PermissionChecks.compareRolesAndPermissions(
        [ROLE_MAP.SUBAUTHREP.code, ROLE_MAP.SUBMEMBER.code],
        permissions
      ) ||
      isFemaUser(permissions))
  ) {
    actions.push({
      text: 'View request',
      value: 'viewRequest',
    });
  }

  if (_.isEqual(rfaStatus, STATUS_PENDING_SUBMISSION)) {
    if (
      PermissionChecks.compareRolesAndPermissions(
        [ROLE_MAP.SUBAUTHREP.code],
        permissions
      ) ||
      (PermissionChecks.compareRolesAndProgramsForSubEntity(
        [ROLE_MAP.SUBMEMBER.code],
        permissions,
        rfaOrgId,
        rfaProgram,
        rfaOrgId
      ) &&
        rfaOrgId === rfaSubOrgId)
    ) {
      actions.push({
        text: 'Continue request',
        value: 'continueRequest',
      });
      actions.push({
        text: 'View request',
        value: 'viewRequest',
      });
    } else if (
      PermissionChecks.compareRolesAndPermissions(
        [
          ROLE_MAP.ORGAOR.code,
          ROLE_MAP.ORGMEMBER.code,
          ROLE_MAP.ORGGRNTWRITER.code,
          ROLE_MAP.ORGPGMMEMBER.code,
        ],
        permissions
      ) ||
      isFemaUser(permissions)
    ) {
      actions.push({
        text: 'View request',
        value: 'viewRequest',
      });
    }
  }
  actions = _.uniqBy(
    _.filter(actions, (action) => _.includes(entitiesEnabled, action.value)),
    'value'
  );
  return actions;
};

export const isStringOfNumbers = (value) => {
  return !/^\d+$/.test(value) ? true : false;
};

export const matchesToggle = (action, toggle, entityType, entityId) => {
  if (action === toggle) {
    return true;
  } else {
    const toggleOptions = _.split(toggle, /(?<!-)-/g);

    return (
      action == _.get(toggleOptions, 2) &&
      entityType === _.get(toggleOptions, 0) &&
      entityId == _.get(toggleOptions, 1)
    );
  }
};

export const matchesFOIDForToggle = (toggle, entityId) => {
  if (
    toggle === undefined ||
    toggle === null ||
    entityId === undefined ||
    entityId === null
  ) {
    return false;
  }
  const toggleOptions = _.split(toggle, /(?<!-)-/g);
  return entityId == _.get(toggleOptions, 1);
};

export const findOffsetTopById = (id) => {
  let obj = document.getElementById(id);
  let offsetTop = 0;
  while (obj != null) {
    offsetTop += obj.offsetTop;
    obj = obj.offsetParent;
  }
  return offsetTop;
};

export const orgRoles = (permissions, renderType, subOrgToggle) => {
  const ROLES = retrieveRolesFromPermissions(permissions);
  const existsSAR = ROLES.includes('21');
  const existsAOR = ROLES.includes('1');

  if (renderType === 'org' && subOrgToggle === true) {
    if (existsSAR || existsAOR) {
      return AOR_SAR_ROLES;
    } else {
      return SARROLES;
    }
  }
  if (renderType === 'subOrg' && subOrgToggle === true) {
    return SARROLES;
  }
  if (subOrgToggle === false) {
    return ROLES;
  }
};

export const scrollIt = (el, destinationOffset, duration = 200) => {
  if (el) {
    const start = el.scrollTop;
    const startTime =
      'now' in window.performance ? performance.now() : new Date().getTime();

    const destinationOffsetToScroll = destinationOffset;

    if ('requestAnimationFrame' in window === false) {
      el.scrollTop = destinationOffsetToScroll;
      return;
    }

    function scroll() {
      const now = 'now' in window.performance ? performance.now() : new Date().getTime();
      const time = Math.min(1, (now - startTime) / duration);
      const toScrollTo = Math.ceil(time * (destinationOffsetToScroll - start) + start);

      el.scrollTop = toScrollTo;

      if (
        toScrollTo === destinationOffsetToScroll ||
        el.scrollTop > el.scrollHeight - window.innerHeight
      ) {
        return;
      }

      requestAnimationFrame(scroll);
    }

    scroll();
  }
};

export const roundUpOrDown = (func, value, precision) => {
  if (value === undefined || func === undefined || precision === undefined) {
    return value;
  }
  const rounder = Math.pow(10, precision);
  return (Math[func](value * rounder) / rounder).toFixed(precision);
};

export const duplicatePhoneNumbers = (phoneNumbers) => {
  let finalPhoneNumbersArray = _.map(phoneNumbers, (pn) => {
    return pn.areaCode + pn.phoneNumber + pn.phoneExtension;
  });
  let result = _.uniq(finalPhoneNumbersArray).length !== finalPhoneNumbersArray.length;
  return result;
};

export const lessThanTwoUniquePhoneNumbers = (phoneNumbers) => {
  let finalPhoneNumbersArray = _.map(phoneNumbers, (pn) => {
    return pn.areaCode + pn.phoneNumber + pn.phoneExtension;
  });
  let result = _.size(_.uniq(finalPhoneNumbersArray)) < 2;
  return result;
};

export const duplicateEmails = (primaryEmail, secondaryEmail) => {
  let result = _.toString(_.trim(primaryEmail)) === _.toString(_.trim(secondaryEmail));
  return result;
};

export const isNewDisasterLocationAdded = (options, prevDate) => {
  if (options && prevDate) {
    let filterOptions = _.find(options, function (item) {
      return moment(item.entryDt, 'YYYY-MM-DD').isAfter(moment(prevDate));
    });
    return _.size(filterOptions) > 0;
  }
  return false;
};

export const getItemNameFromRef = (itemCode, refItems) => {
  const itemData = _.find(
    refItems,
    (ref) => _.toInteger(ref.itemCode) === _.toInteger(itemCode)
  );
  return _.get(itemData, 'name');
};

export const getBudgetItemsAtTier = (
  items,
  refItems,
  predicate,
  remainingTiers,
  path = ''
) => {
  const matchingTierItems = _.map(items, (item, itemKey) => {
    if (remainingTiers == 0) {
      const itemCode = _.get(item, 'itemCode', -1);
      const itemName = getItemNameFromRef(itemCode, refItems);
      const itemPath = `${path}.${itemKey}`;
      const projectName = _.get(item, 'additionalInformation.projectName', false)
        ? ` ${_.get(item, 'additionalInformation.projectName')}`
        : '';
      if (predicate(item)) {
        return {
          itemKey,
          itemCode,
          itemName,
          itemPath,
          projectName,
        };
      } else {
        return null;
      }
    } else {
      const nestedPath = `${path ? path + '.' : ''}${itemKey}.children`;
      return getBudgetItemsAtTier(
        _.get(item, 'children', {}),
        refItems,
        predicate,
        remainingTiers - 1,
        nestedPath
      );
    }
  });
  return _.filter(_.flatMap(matchingTierItems), (item) => item !== null);
};

export const calculateStatuses = (sectionResults) => {
  const sectionStatuses = {};

  _.forEach(sectionResults, (result, sectionName) => {
    const canSubmit = _.get(result, CAN_SUBMIT);
    const canSubmitPositive = _.get(result, CAN_SUBMIT_POSITIVE);

    let status;
    if (!canSubmit) {
      status = 'incomplete';
    } else if (canSubmitPositive) {
      status = 'complete';
    } else {
      status = 'needsAttention';
    }
    _.set(sectionStatuses, sectionName, status);
  });
  return sectionStatuses;
};

export const buildParamString = (templateNames, params) => {
  let paramString = '';
  _.forEach(templateNames, (name) => {
    paramString += `templateName=${name}&`;
  });
  _.forEach(params, (entry) => {
    paramString += `${entry.name}=${entry.value}&`;
  });
  paramString = paramString.slice(0, -1);
  return paramString;
};

export const fillArray = (collection, defaultValue) => {
  let result = [];
  _.each(collection, (item, index) => {
    if (_.isUndefined(item) || _.isNull(item) || item === '') {
      result.push(defaultValue);
    } else {
      result.push(item);
    }
  });
  return result;
};

export const removeLeadingZeros = (value) => {
  // '0010' -> 10, '00100.00' -> '100.00', '000' -> '0', '0000.00' -> '0.00'
  return value.replace(/^0+(?=\d)/, '');
};

export const buildOrgRelationshipOrganizationProgramsUrl = (
  isRestricted,
  orgId,
  subOrgId
) => {
  let endpoint;

  endpoint = `organization-programs?restricted=${isRestricted}`;
  if (checkIfDefinedNonNullAndNotEmptyString(subOrgId)) {
    endpoint += `&organizationId=${orgId}&subOrganizationId=${subOrgId}`;
  } else if (checkIfDefinedNonNullAndNotEmptyString(orgId)) {
    endpoint += `&organizationId=${orgId}`;
  }

  return endpoint;
};

export const getUniqs = (collection, field) => {
  // Get truthy fields
  return _.chain(collection).map(field).uniq().compact().value();
};

export const getPartName = (
  itemCode,
  refItems,
  partId = null,
  fundingStreams = null,
  separator = ' '
) => {
  const itemCodeName = getItemNameFromRef(itemCode, refItems) || _.toString(itemCode);
  const projectNameForPart =
    fundingStreams && partId
      ? _.get(fundingStreams, partId + '.additionalInformation.projectName', '')
      : '';
  return _.trim(`${itemCodeName}${separator}${projectNameForPart}`);
};

// Filter my permissions for only those in which there are not some excluded roles
// which the permission contains
export const filterExcludedRolesFromPermissions = (permissions, roles) => {
  return _.filter(
    permissions,
    (permission) => !_.some(roles, (role) => _.endsWith(permission, `:${role}`))
  );
};

export const getPartIdWithoutChildrenPath = (partId) => {
  return partId.split('.').pop();
};

export const usePresignedUrl = () => {
  return unpartitionedToggleIsOn(goStore.store.getState(), 'usePresignedUrl');
};
export const encode = (uri) => {
  // Single quote and parantheses is not encoded by encodeURIComponent
  return encodeURIComponent(uri)
    .replace(/'/g, '%27')
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29');
};

// gets the funding stream type for POP amendments (used for SAFER only)
export const getFundingStreamType = (fundingStreams) => {
  const fundingStreamTypes = _.map(fundingStreams, (stream) =>
    _.get(stream, 'fundingStreamType', '')
  );
  if (_.includes(fundingStreamTypes, RECRUITMENT_AND_RETENTION)) {
    return RECRUITMENT_AND_RETENTION;
  } else if (_.includes(fundingStreamTypes, HIRING_OF_FIREFIGHTERS)) {
    return HIRING_OF_FIREFIGHTERS;
  } else {
    return '';
  }
};
export const FLUX = 'FLUX';
export const MONO = 'MONO';
// fetches an updated POP from rules service
export const fetchPOPupdate = async (payloadUpdate, ruleSet) => {
  try {
    const staticPayload = {
      configType: 'fo',
      ruleSet: ruleSet,
    };
    const payload = {...staticPayload, ...payloadUpdate};
    const response = await REST.rules.getRulesByPayload('', payload);
    const [[responseObject]] = await forceJsonResponse(response, FLUX);
    return responseObject ? responseObject.updatedGrantAmendment : null;
  } catch (error) {
    console.log(error);
  }
};

//Function used for the grants list page to filter display by subApps or subGrants
export const subApplicationsToSubGrantsFilter = (subApps, subGrants) => {
  return _.map(subApps, (subApp) => {
    let matchingSubGrant = _.find(
      subGrants,
      (subGrant) => subGrant.subGrantId === subApp.subGrantId
    );
    if (matchingSubGrant) {
      return {
        ...matchingSubGrant,
        categoryId: subApp.categoryId,
      };
    } else {
      return subApp;
    }
  });
};

// filter and return only entities that do not have the "entityType" property
export const filterByEntityType = (entities, entityType) => {
  let cloneEntities = _.cloneDeep(entities);
  let filteredEntities = _.filter(cloneEntities, (el) =>
    notHaveEntityType(el, entityType)
  );
  return filteredEntities;
};

const notHaveEntityType = (cloneEntity, entityType) => {
  if (_.has(cloneEntity, 'entityTypeId')) {
    if (cloneEntity.entityTypeId !== entityType) {
      return true;
    }
  }
  return false;
};
export const downloadPresignedLink = (resourceId) => {
  return REST.attachment
    .getAttachmentDownloadPresignedUrl(resourceId)
    .then((res) => {
      return forceJsonResponse(res, MONO);
    })
    .then((responseJson) => {
      const url = new URL(responseJson['pre-signedurl']);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${resourceId}`);
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      console.error('error');
    });
};

export const evaluateTemplateString = (template, params) => {
  const keys = Object.keys(params);
  const values = Object.values(params);
  return Function(...keys, `'use strict'; return (${template})`)(...values);
};

export const isLoginGovUser = () => {
  const cookies = new Cookies(null, {path: '/'});
  const isLoginGovUser = cookies.get('isLoginGovUser');
  return !_.isEmpty(isLoginGovUser);
};

export const isloginGovError = () => {
  const cookies = new Cookies(null, {path: '/'});
  const internalLoginGovErrorCookie = cookies.get(COOKIES.LOGINGOVERROR);
  const isLoginGovError = internalLoginGovErrorCookie
    ? JSON.parse(atob(internalLoginGovErrorCookie))
    : null;
  return isLoginGovError
    ? isLoginGovError.hasOwnProperty('loginGovError')
      ? isLoginGovError.loginGovError
      : false
    : false;
};

export const isInternalDHSUser = () => {
  const cookies = new Cookies(null, {path: '/'});
  const internalDHSUserCookie = cookies.get(COOKIES.LOGINGOVERROR);

  const isInternalDHSUser = internalDHSUserCookie
    ? JSON.parse(atob(internalDHSUserCookie))
    : null;
  return isInternalDHSUser
    ? isInternalDHSUser.hasOwnProperty('isDHSUserEmail')
      ? isInternalDHSUser.isDHSUserEmail
      : false
    : false;
};

export const removeEmptyIds = (ids) => {
  return _.chain(ids).split(',').filter(_.identity).join(',').value();
};

export const ENTITY_TYPE_NAME_MAP = {
  amendment: 'Amendment',
  application: 'Application',
  bsirReport: 'Biannual Strategy Implementation Report',
  ehpQuestionnaire: 'Environmental and Historic Preservation Questionnaire',
  financialReport: 'Financial Report',
  closeoutReport: 'Closeout Report',
  payment: 'Payment',
  performanceProgressReport: 'Performance Progress Report',
  returnOfFund: 'Return of Funds',
  rfa: 'Request for Assistance',
  rfi: 'Request for Information',
  subAmendmentRecommendation: 'Subamendment Recommendation',
  subApplication: 'Subapplication',
  subAppSubmissionToFEMA: 'Subapplication',
  subCloseoutReport: 'Subcloseout Report',
  grant: 'Grant',
  subGrant: 'Subgrant',
};

/**
 * Inspect the response object provided to see if it is of the type
 * that is provided when backend API call returns an empty 200 response.
 * When the redux-api-middleware library tries to process the response
 * it gets and error invoking the json() method and that error is
 * reflected in the response
 *
 * @param {*} responseObj - response from API call
 *    e.g., getDynamicDataByEntityId(token, entityId).then((res) => {...}), res is responesObj
 * @returns true if it has properties of a response object resembling result of empty response body,
 * false otherwise.  Such response has responseObj.error true, responseObj.type ~ /.*SUCCESS/, and
 * response.payload.message is that particular error message below ending with
 * "Unexpected end of JSON input".
 */
export const isEmptySuccessResponseError = (responseObj) => {
  if (!responseObj) return false;
  const isError = _.get(responseObj, 'error', false);
  const isSuccessType = _.endsWith(_.get(responseObj, 'type', ''), 'SUCCESS');

  if (_.isEmpty(_.get(responseObj, 'payload')) && !isError) return true;

  return isError && isSuccessType;
};

/**
 *
 * @param {*} response
 * @returns the json content of the response or an empty json object
 */
export const forceJsonResponse = async (response, type) => {
  try {
    let json = await response.json();
    return Promise.resolve(json);
  } catch (error) {
    console.warn(
      'Unable to convert response to json object. returning empty object instead'
    );
    if (type == FLUX) return Promise.resolve([]);
    else return Promise.resolve({});
  }
};

export const getGroupName = (groups, groupId) => {
  const groupDetails = _.filter(groups.content, (g) => g.groupId == groupId);
  if (groupDetails.length > 0) return groupDetails[0].name;
};

export const fetchMoreOrgData = (rslts, fetchInfo, limit, offset, results) => {
  let increment = 0;
  if (rslts.length >= limit) {
    increment = increment + 1;
  }
  if (fetchInfo !== undefined && !_.isEmpty(fetchInfo)) {
    results = rslts;
  } else {
    results = results.concat(rslts);
  }
  return {
    loading: false,
    results: results,
    showSearch: true,
    offset: offset + increment,
    hasMore: rslts.length >= limit,
    orgError: false,
    searchError: true,
  };
};

export const getSubOrganizationId = (obj) => {
  return _.has(obj, 'subOrgId')
    ? _.get(obj, 'subOrgId')
    : _.get(obj, 'subOrganizationId');
};

export const isTokenNewer = (cookieToken, stateToken) => {
  try {
    const cookieDecoded = jwt_decode(cookieToken);
    return cookieDecoded.iat > stateToken.iat;
  } catch (error) {
    return false;
  }
};
